{
  "common": {
    "from": "from {{price}}",
    "soon": "soon",
    "online": "Online",
    "back": "Back",
    "close": "Close",
    "cancel": "Cancel",
    "apply": "Apply",
    "retry": "Retry",
    "retryLater": "Please try again a bit later.",
    "loading": "Loading…",
    "increase": "More",
    "decrease": "Less"
  },
  "categories": {
    "HOME": {
      "name": "Home",
      "short": "Cleaning, repairs, transfers"
    },
    "DOCS": {
      "name": "Documents",
      "short": "Social card, translation, residence"
    },
    "LEARNING": {
      "name": "Learning & career",
      "short": "Languages and career coach"
    },
    "PERKS": {
      "name": "Discounts & gifts",
      "short": "Cafés, restaurants, gifts"
    }
  },
  "services": {
    "cleaning": {
      "name": "Cleaning",
      "description": "Regular, deep or post-renovation. Vetted cleaners and a photo report afterwards."
    },
    "repair": {
      "name": "Repairs",
      "description": "Plumbing, electrics and small fixes. The handyman agrees the estimate with you first."
    },
    "transfer": {
      "name": "Transfer",
      "description": "We'll meet you at the airport or take you to your flight."
    },
    "social_card": {
      "name": "Social card",
      "description": "We'll help you get your social card."
    },
    "passport_translation": {
      "name": "Passport translation",
      "description": "Notarised passport translation."
    },
    "residence_permit": {
      "name": "Residence permit",
      "description": "Support all the way to your residence permit."
    },
    "lang_armenian": {
      "name": "Armenian",
      "description": "A pack of Armenian lessons, online or in person."
    },
    "lang_english": {
      "name": "English",
      "description": "A pack of English lessons, online or in person."
    },
    "career": {
      "name": "Career coach",
      "description": "CV review and a job-search plan."
    }
  },
  "params": {
    "cleaning": {
      "cleaningType": {
        "label": "Cleaning type",
        "regular": "Regular",
        "regular_hint": "Maintenance cleaning",
        "general": "Deep",
        "general_hint": "Everything, including hard-to-reach spots",
        "renovation": "Post-renovation",
        "renovation_hint": "Dust, paint and cement marks"
      },
      "rooms": {
        "label": "Rooms",
        "count_one": "{{count}} room",
        "count_few": "{{count}} rooms",
        "count_many": "{{count}} rooms",
        "count_other": "{{count}} rooms"
      },
      "bathrooms": {
        "label": "Bathrooms",
        "count_one": "{{count}} bathroom",
        "count_few": "{{count}} bathrooms",
        "count_many": "{{count}} bathrooms",
        "count_other": "{{count}} bathrooms"
      }
    },
    "repair": {
      "repairType": {
        "label": "What happened",
        "plumbing": "Plumbing",
        "plumbing_hint": "Taps, pipes, toilet",
        "electrical": "Electrics",
        "electrical_hint": "Sockets, lights, wiring",
        "minor": "Small fixes",
        "minor_hint": "Shelves, doors, furniture"
      },
      "problem": {
        "label": "Describe the problem"
      }
    },
    "transfer": {
      "direction": {
        "label": "Direction",
        "fromAirport": "From the airport",
        "fromAirport_hint": "Meet & greet with a sign",
        "toAirport": "To the airport",
        "toAirport_hint": "We'll get you to your flight"
      },
      "flight": {
        "label": "Flight number"
      },
      "passengers": {
        "label": "Passengers"
      },
      "luggage": {
        "label": "Pieces of luggage"
      }
    },
    "social_card": {
      "forWhom": {
        "label": "For whom",
        "self": "For me",
        "self_hint": "One person",
        "family": "For my family",
        "family_hint": "Several people"
      }
    },
    "passport_translation": {
      "forWhom": {
        "label": "For whom",
        "self": "For me",
        "self_hint": "One passport",
        "family": "For my family",
        "family_hint": "Several passports"
      }
    },
    "residence_permit": {
      "forWhom": {
        "label": "For whom",
        "self": "For me",
        "self_hint": "One person",
        "family": "For my family",
        "family_hint": "Several people"
      }
    },
    "lang_armenian": {
      "level": {
        "label": "Level",
        "A1": "A1",
        "A1_hint": "Beginner",
        "A2": "A2",
        "A2_hint": "Elementary",
        "B1": "B1",
        "B1_hint": "Intermediate",
        "B2": "B2",
        "B2_hint": "Upper-intermediate"
      },
      "format": {
        "label": "Format",
        "online": "Online",
        "online_hint": "Video call",
        "offline": "In person",
        "offline_hint": "In Yerevan"
      },
      "lessons": {
        "label": "Pack",
        "4": "4 lessons",
        "4_hint": "Try it out",
        "8": "8 lessons",
        "8_hint": "One month",
        "12": "12 lessons",
        "12_hint": "Intensive"
      }
    },
    "lang_english": {
      "level": {
        "label": "Level",
        "A1": "A1",
        "A1_hint": "Beginner",
        "A2": "A2",
        "A2_hint": "Elementary",
        "B1": "B1",
        "B1_hint": "Intermediate",
        "B2": "B2",
        "B2_hint": "Upper-intermediate",
        "C1": "C1",
        "C1_hint": "Advanced"
      },
      "format": {
        "label": "Format",
        "online": "Online",
        "online_hint": "Video call",
        "offline": "In person",
        "offline_hint": "In Yerevan"
      },
      "lessons": {
        "label": "Pack",
        "4": "4 lessons",
        "4_hint": "Try it out",
        "8": "8 lessons",
        "8_hint": "One month",
        "12": "12 lessons",
        "12_hint": "Intensive"
      }
    },
    "career": {
      "topic": {
        "label": "Topic",
        "resume": "CV review",
        "resume_hint": "What to improve",
        "jobSearch": "Job-search plan",
        "jobSearch_hint": "Where and how to apply"
      }
    }
  },
  "extras": {
    "windows": {
      "name": "Window cleaning",
      "per": "per window"
    },
    "balconyGlazing": {
      "name": "Balcony glazing",
      "per": "per balcony"
    },
    "balcony": {
      "name": "Balcony cleaning",
      "per": "per balcony"
    },
    "fridge": {
      "name": "Inside the fridge"
    },
    "oven": {
      "name": "Inside the oven"
    },
    "microwave": {
      "name": "Inside the microwave"
    },
    "kitchenCabinets": {
      "name": "Inside kitchen cabinets"
    },
    "complexKitchen": {
      "name": "Heavily soiled kitchen"
    },
    "chandelier": {
      "name": "Chandelier",
      "per": "each"
    },
    "wardrobe": {
      "name": "Walk-in wardrobe"
    },
    "limescale": {
      "name": "Limescale and rust in the bathroom"
    },
    "petHair": {
      "name": "Pet hair removal"
    },
    "litter": {
      "name": "Pet litter box",
      "per": "each"
    },
    "ironing": {
      "name": "Ironing",
      "per": "per hour"
    },
    "extraTime": {
      "name": "Extra time",
      "per": "per 30 min"
    },
    "keys": {
      "name": "Key pickup and return"
    },
    "experienced": {
      "name": "Experienced cleaner"
    },
    "vacuum": {
      "name": "Bring a vacuum cleaner"
    }
  },
  "checklist": {
    "kitchen": "Kitchen",
    "bathroom": "Bathroom",
    "rooms": "Rooms",
    "floors": "Floors",
    "photoReport": "Photo report",
    "diagnostics": "Diagnostics",
    "estimate": "Estimate",
    "repair": "Repair",
    "photo": "Photo",
    "luggage": "Luggage",
    "address": "Address",
    "review": "Review",
    "newTopic": "New topic",
    "homework": "Homework",
    "resume": "CV",
    "plan": "Plan",
    "materials": "Materials"
  },
  "status": {
    "CLEANING": {
      "NEW": "New",
      "ASSIGNED": "Assigned",
      "EN_ROUTE": "On the way",
      "CLEANING": "Cleaning",
      "DONE": "Done",
      "CANCELLED": "Cancelled"
    },
    "REPAIR": {
      "NEW": "New",
      "ASSIGNED": "Assigned",
      "ON_SITE": "On site",
      "ESTIMATE_APPROVED": "Estimate approved",
      "REPAIRING": "Repairing",
      "DONE": "Done",
      "CANCELLED": "Cancelled"
    },
    "TRANSFER": {
      "NEW": "New",
      "ASSIGNED": "Assigned",
      "DRIVER_WAITING": "Driver waiting",
      "RIDE_IN_PROGRESS": "On the way",
      "COMPLETED": "Completed",
      "CANCELLED": "Cancelled"
    },
    "LANGUAGE": {
      "ENROLLED": "Enrolled",
      "LESSON_SCHEDULED": "Lesson scheduled",
      "LESSON_IN_PROGRESS": "Lesson in progress",
      "LESSON_DONE": "Lesson finished",
      "COMPLETED": "Pack completed",
      "CANCELLED": "Cancelled"
    },
    "CAREER": {
      "NEW": "New",
      "CONSULTANT_ASSIGNED": "Coach assigned",
      "RESUME_RECEIVED": "CV received",
      "MEETING": "Meeting",
      "PLAN_SENT": "Plan sent",
      "CANCELLED": "Cancelled"
    },
    "DOCUMENTS": {
      "NEW": "New",
      "DOCS_REVIEW": "Checking documents",
      "NEEDS_MORE_DOCS": "More documents needed",
      "SUBMITTED": "Submitted",
      "DONE": "Done",
      "CANCELLED": "Cancelled"
    }
  },
  "payment": {
    "UNPAID": "Unpaid",
    "PAID": "Paid",
    "REFUNDED": "Refunded"
  },
  "roles": {
    "CLEANER": "Cleaner",
    "HANDYMAN": "Handyman",
    "DRIVER": "Driver",
    "TEACHER": "Teacher",
    "CAREER_CONSULTANT": "Career coach",
    "DOCS_AGENT": "Documents specialist"
  },
  "districts": {
    "ajapnyak": "Ajapnyak",
    "arabkir": "Arabkir",
    "avan": "Avan",
    "davtashen": "Davtashen",
    "erebuni": "Erebuni",
    "kanaker_zeytun": "Kanaker-Zeytun",
    "kentron": "Kentron",
    "malatia_sebastia": "Malatia-Sebastia",
    "nork_marash": "Nork-Marash",
    "nor_nork": "Nor Nork",
    "nubarashen": "Nubarashen",
    "shengavit": "Shengavit"
  },
  "plans": {
    "free": {
      "perks": "Partner discounts and gifts",
      "prices": "All services at the regular price",
      "status": "Order statuses and chat"
    },
    "plus": {
      "price": "{{price}}/mo",
      "all": "Everything in Barev",
      "discount": "−{{pct}}% on “{{category}}”"
    }
  },
  "errors": {
    "generic": "Something went wrong. Please try again.",
    "NOT_FOUND": "We couldn't find this order.",
    "FORBIDDEN": "Access denied.",
    "CONSENT_REQUIRED": "Please consent to personal data processing first.",
    "SERVICE_UNAVAILABLE": "This service isn't available yet.",
    "INVALID_PARAMS": "Please check the order details.",
    "SLOT_UNAVAILABLE": "This time has just been taken. Please pick another.",
    "ADDRESS_REQUIRED": "Please enter your district and address.",
    "TRANSITION_NOT_ALLOWED": "This step isn't available right now. Refresh the screen.",
    "CHECKLIST_INCOMPLETE": "Tick every item on the checklist.",
    "PHOTO_REQUIRED": "This item needs a photo.",
    "ESTIMATE_NOT_ACCEPTED": "The client hasn't approved the estimate yet.",
    "CANCEL_VIA_OPERATOR": "The service has already started — only an operator can cancel it now.",
    "RESCHEDULE_VIA_OPERATOR": "Only an operator can reschedule this order.",
    "AGENCY_CODE_INVALID": "That code doesn't exist. Check the code in your lease.",
    "AGENCY_ALREADY_SET": "You're already linked to another real estate agency.",
    "OFFER_NOT_ACTIVE": "This offer is no longer valid.",
    "PROVIDER_BUSY": "The specialist is busy at that time.",
    "ALREADY_ASSIGNED": "The order is already assigned.",
    "INVITE_INVALID": "This invite link is invalid. Ask the operator for a new one.",
    "NOT_PAID_STATE": "This order can't be marked as paid.",
    "BAD_CREDENTIALS": "Wrong login or password.",
    "BAD_TOTP": "Wrong code. Check the time on your phone.",
    "LOGIN_THROTTLED": "Too many attempts. Wait 15 minutes.",
    "OWNER_ONLY": "Owner only.",
    "NOT_LINKED": "Account not linked.",
    "NOT_PROVIDER": "Specialists only.",
    "CANNOT_DISABLE_SELF": "You can't disable yourself.",
    "AGENCY_CODE_FORMAT": "The code must be Latin letters and digits.",
    "TOTP_ALREADY_ENABLED": "2FA is already set up.",
    "ADMIN_LOGIN_REQUIRED": "Please sign in.",
    "ADMIN_2FA_REQUIRED": "Please confirm sign-in with a code.",
    "INIT_DATA_MISSING": "Open the app from Telegram.",
    "INIT_DATA_BAD_HASH": "Open the app from Telegram.",
    "INIT_DATA_EXPIRED": "Session expired. Reopen the app.",
    "BAD_FILE_TYPE": "A photo is required (JPG, PNG, WEBP).",
    "NO_FILE": "No file selected.",
    "UPLOAD": "Couldn't upload the photo.",
    "PHONE_INVALID": "Check the phone number.",
    "REQUEST_THROTTLED": "Too many requests in a row. Try again in 15 minutes.",
    "CONTACT_INVALID": "We need a phone number (+374…) or a Telegram username (@username).",
    "NAME_REQUIRED": "Tell us what to call you.",
    "PROVIDER_NOT_LINKED": "The provider hasn’t opened the work bot via the invite yet — nowhere to send messages.",
    "CARD_EXPIRED": "The QR is out of date or invalid — ask the client to reopen the card.",
    "OFFER_NOT_AVAILABLE": "This offer isn’t available at the client’s level.",
    "OFFER_LIMIT_REACHED": "The limit for this offer is already used up.",
    "CONCIERGE_SUBSCRIBERS_ONLY": "The personal concierge is for Barev+ and Barev Elite members. For now, write to support — we will help too.",
    "ASSIGNEE_NO_ACCESS": "This team member has no access to this channel.",
    "PROMO_INVALID": "This promo code doesn't exist",
    "PROMO_EXPIRED": "This promo code is no longer valid",
    "PROMO_USED": "This promo code has already been used",
    "PROMO_NOT_FOR_SERVICE": "This promo code doesn't apply to this service",
    "POINTS_DUPLICATE_ORDER": "Bariki for this order have already been credited.",
    "POINTS_REASON_REQUIRED": "Please give a reason.",
    "POINTS_BELOW_MIN": "The amount is below the minimum.",
    "POINTS_NOT_ENOUGH": "Not enough bariki.",
    "POINTS_OVER_SHARE": "Bariki can cover only part of the order.",
    "POINTS_OVER_LIMIT": "Above your limit — a super admin must approve.",
    "POINTS_FINAL": "This operation can no longer be reversed.",
    "POINTS_REQUEST_CLOSED": "The request is already handled or expired.",
    "POINTS_TOO_MANY_REQUESTS": "You already have pending requests — please wait for a reply.",
    "POINTS_WITH_PROMO": "Bariki can’t be combined with a promo code.",
    "PAYMENT_UNAVAILABLE": "Online payment is unavailable right now — please message an operator.",
    "PAYMENT_AMOUNT_OUT_OF_RANGE": "This amount can’t be paid online — an operator will help you pay.",
    "ALREADY_SUBSCRIBED": "You already have a membership with auto-renewal.",
    "PAYMENT_PROVIDER_ERROR": "The payment service didn’t respond. Please try again a bit later."
  },
  "client": {
    "nav": {
      "label": "Navigation",
      "home": "Home",
      "services": "Services",
      "newOrder": "New order",
      "perks": "Perks",
      "profile": "Profile",
      "plan": "Plan",
      "docs": "Documents",
      "orders": "Orders",
      "card": "Card",
      "chat": "Chat"
    },
    "openInTelegram": {
      "title": "Open in Telegram",
      "text": "Barev Club lives inside Telegram. Tap “Open app” in our bot."
    },
    "consent": {
      "title": "Almost there",
      "text": "To place orders we need your consent to process personal data: your name, address and order details. They go to the specialist doing your order and the partners listed in the policy, and are stored on a server in Germany.",
      "policyLink": "Privacy policy",
      "accept": "I agree, continue",
      "giftToast": "Your real estate agency gift is active"
    },
    "home": {
      "hello": "Barev!",
      "guest": "Friend",
      "myOrders": "My orders",
      "allOrders": "All",
      "noOrders": "No orders yet. Book your first service — it takes 2 minutes.",
      "repeatLast": "Repeat",
      "enterCode": "Real estate agency code",
      "plusUntil": "Barev+ active until {{date}}",
      "discount": "−{{pct}}% with Barev+",
      "upsellTitle": "Up to −{{pct}}% with Barev Elite",
      "upsellText": "Cleaning, repairs, transfers, paperwork and partner gifts",
      "levelUntil": "{{plan}} active until {{date}}",
      "now": "Now",
      "moreActive": "More active: {{count}}",
      "orderTitle": "Book a service",
      "cardShow": "Show QR",
      "free": "Free level",
      "chatTitle": "Any question — ask in chat",
      "chatText": "We reply in your language"
    },
    "services": {
      "title": "Services",
      "plusDiscount": "Your Barev+ discount: −{{pct}}%",
      "callback": "Request a call",
      "yourDiscount": "Your discount −{{pct}}%",
      "withElite": "−{{pct}}% with Barev Elite"
    },
    "order": {
      "unavailable": "This service is coming very soon.",
      "duration": "About {{hours}} h",
      "when": "When",
      "date": "Date",
      "noSlots": "No free time on this day. Pick another day.",
      "pickSlot": "Pick a time.",
      "address": "Address",
      "district": "District",
      "districtPlaceholder": "Choose a district",
      "pickDistrict": "Choose a district.",
      "addressLabel": "Street, building, apartment",
      "addressPlaceholder": "10 Pushkin St, apt 15",
      "enterAddress": "Enter the address.",
      "note": "Note for the specialist",
      "notePlaceholder": "Intercom, floor, pets…",
      "payment": "Payment",
      "paymentHint": "Pay after the service. Online payment is coming later.",
      "price": "Price",
      "discount": "Barev+ discount −{{pct}}%",
      "plusHint": "With Barev+ it would be {{pct}}% cheaper",
      "total": "Total",
      "confirm": "Confirm order",
      "cancelPolicy": "Free cancellation and rescheduling up to {{hours}} h before. Later — a {{pct}}% fee.",
      "created": "Order #{{number}} created",
      "extras": "Extras",
      "add": "Add",
      "promo": "Promo code",
      "promoPlaceholder": "Promo code, if you have one",
      "promoApply": "Apply",
      "promoRemove": "Remove",
      "promoLine": "Promo {{code}} −{{pct}}%",
      "promoWeaker": "Your membership discount is bigger, so it applies"
    },
    "orders": {
      "title": "My orders",
      "active": "Active",
      "history": "History",
      "noHistory": "Completed orders will appear here.",
      "order": "Book a service"
    },
    "detail": {
      "progress": "Status",
      "arrived": "has arrived",
      "photoReport": "Photo report",
      "cancelFee": "Cancellation fee",
      "reschedule": "Reschedule",
      "rescheduleConfirm": "Move to this time",
      "rescheduled": "Order rescheduled",
      "cancel": "Cancel order",
      "confirmCancelFree": "Cancel the order? Cancellation is free.",
      "confirmCancelLate": "Less than a day to go — we'll keep {{fee}} ({{pct}}%). Cancel?",
      "cancelled": "Order cancelled",
      "cancelledWithFee": "Order cancelled. Fee: {{fee}}",
      "viaOperator": "Less than {{hours}} h before the start, you can cancel or reschedule only via an operator — message the bot.",
      "repeat": "Repeat order",
      "orderAgain": "Order again",
      "providerLabel": {
        "CLEANING": "Cleaner",
        "REPAIR": "Handyman",
        "TRANSFER": "Driver",
        "LANGUAGE": "Teacher",
        "CAREER": "Coach",
        "DOCUMENTS": "Specialist"
      },
      "when": "When",
      "where": "Where",
      "who": "Provider",
      "whoPending": "being assigned",
      "payment": "Payment",
      "ask": "Question about this order",
      "payOnline": "Pay online · {{price}}",
      "payOnlineHint": "By card via Tribute, in euros at the current rate: {{amd}} ≈ {{rub}}",
      "payAwaiting": "Waiting for payment confirmation…",
      "paidOnline": "Payment received, thank you!"
    },
    "perks": {
      "title": "Perks",
      "soonTitle": "Partners coming soon",
      "soonText": "Cafés, restaurants and partner gifts will appear here. Show your club card at the till."
    },
    "profile": {
      "title": "Profile",
      "fromAgency": "Client of real estate agency {{agency}}",
      "noAgency": "No real estate agency",
      "membership": "Barev / Barev+ membership",
      "codeTitle": "Real estate agency code",
      "codeText": "Rented through a partner real estate agency? Enter the code from your lease and get a gift from the agency.",
      "codePlaceholder": "e.g. DOMIK",
      "codeAccepted": "Code accepted: {{agency}}",
      "codeGift": "Code accepted: {{agency}}. Your gift is active!",
      "language": "Language"
    },
    "membership": {
      "title": "Membership",
      "current": "Your plan",
      "howToGet": "You can get Barev+ as a gift with a real estate agency code. Online subscription is coming very soon.",
      "request": "Get {{plan}}",
      "requested": "Request sent — an operator will be in touch",
      "requestHint": "An operator will message you on Telegram, arrange payment and switch the subscription on.",
      "pendingTitle": "Request sent",
      "pendingText": "An operator will be in touch soon to switch the subscription on.",
      "approx": "≈ {{amd}} · ≈ {{rub}} — charged in euros",
      "pay": "Get {{plan}} for {{price}}/mo",
      "payRenew": "Turn on auto-renewal · {{price}}/mo",
      "payHint": "Card payment via Tribute. Renews every month — you can turn it off here at any time.",
      "payOther": "Pay another way — via an operator",
      "renewOn": "Auto-renewal is on",
      "nextCharge": "Next charge on {{date}} — {{price}}",
      "renewOffButton": "Turn off auto-renewal",
      "renewOffConfirm": "Turn off auto-renewal? Your membership stays active until the end of the paid month.",
      "renewOff": "Auto-renewal turned off",
      "switchHint": "You have {{plan}} with auto-renewal. To switch plans, turn off its auto-renewal first.",
      "awaitingTitle": "Waiting for payment confirmation",
      "awaitingText": "It usually takes a few seconds. Your membership will turn on automatically.",
      "paid": "Payment received — membership is on"
    },
    "segment": {
      "title": "Hi! Tell us about yourself",
      "sub": "We'll show what matters to you. You can change it in your profile.",
      "moving": "I'm moving",
      "movingText": "Step-by-step moving plan, documents and a concierge",
      "living": "I already live in Armenia",
      "livingText": "Discounted services, club partners and orders",
      "profileTitle": "My scenario"
    },
    "move": {
      "title": "My move",
      "daysLeft_one": "in {{count}} day",
      "daysLeft_few": "in {{count}} days",
      "daysLeft_many": "in {{count}} days",
      "daysLeft_other": "in {{count}} days",
      "progress": "{{done}} of {{total}} steps done",
      "noSteps": "An operator will get in touch and draw up the plan — the steps will appear here.",
      "afterTitle": "Already moved?",
      "afterText": "Switch to “I already live in Armenia” in your profile for discounted services and club partners.",
      "formHello": "{{name}}, let's start",
      "formTitle": "Let's plan your move",
      "formSub": "Answer a couple of questions — an operator will draw up a plan and a price.",
      "whenTitle": "When are you moving?",
      "packageTitle": "What do you need?",
      "customTitle": "Pick the services you need",
      "errPackage": "Pick a package.",
      "errWhen": "Pick an option or set a date.",
      "errEmpty": "Pick at least one service.",
      "comment": "Comment",
      "commentHint": "How many of you, kids or pets, anything important",
      "submit": "Send the plan",
      "created": "Plan sent — an operator will be in touch soon",
      "status": {
        "TODO": "to do",
        "IN_PROGRESS": "in progress",
        "DONE": "done",
        "SKIPPED": "not needed"
      }
    },
    "docs": {
      "title": "Documents",
      "sub": "What to prepare before the move. Tick them off so nothing gets forgotten.",
      "progress": "{{done}} of {{total}} ready",
      "needPlan": "Plan your move first — then tick off documents.",
      "ask": "Ask the concierge"
    },
    "concierge": {
      "title": "Concierge",
      "short": "Write in the chat — we'll answer there"
    },
    "request": {
      "title": "Request a call",
      "sub": "An operator will get in touch, clarify the details and place the order.",
      "comment": "What needs doing",
      "commentHint": "E.g. the kitchen tap is leaking, after 6 pm works best",
      "submit": "Send request",
      "sentTitle": "Request #{{number}} sent",
      "sentText": "An operator will get in touch during working hours.",
      "back": "Back to services",
      "yourDiscount": "Your subscription discount −{{pct}}%"
    },
    "partners": {
      "howTo": "Show the QR at the till — staff scan it with a camera. The code changes every minute, so screenshots won’t work.",
      "cat": {
        "cafe": "Café",
        "restaurant": "Restaurant",
        "shop": "Shop",
        "beauty": "Beauty",
        "other": "Other"
      },
      "qrLabel": "Club card QR",
      "qrRefresh": "refreshes in {{seconds}} s",
      "allMembers": "all members",
      "needLevel": "with {{level}}",
      "limit_ONCE": "first visit",
      "limit_WEEK": "{{count}}× a week",
      "limit_MONTH": "{{count}}× a month",
      "used_ONCE": "already used",
      "used_WEEK": "again next week",
      "used_MONTH": "again next month"
    },
    "chat": {
      "title": "Chat with Barev Club",
      "support": "Support",
      "concierge": "Personal concierge",
      "hint": "This is the same conversation as in the bot chat: replies arrive here and in Telegram.",
      "empty": "Tell us how we can help — we’ll reply here.",
      "placeholder": "Message…",
      "send": "Send",
      "attach": "Attach a photo or file",
      "conciergeOnly": "The personal concierge comes with Barev+ and Barev Elite",
      "team": "Barev Club",
      "fileTooBig": "The file is larger than 10 MB",
      "file": "File"
    },
    "rate": {
      "title": "How did it go?",
      "text": "Your rating helps us keep the quality high",
      "comment": "Comment — optional",
      "send": "Rate",
      "thanks": "Thanks for your rating!",
      "yours": "Your rating",
      "change": "Change",
      "star": "{{count}} of 5",
      "prompt": "Rate your order"
    },
    "card": {
      "title": "Club card",
      "partners": "Club partners",
      "plans": "Levels and discounts"
    },
    "points": {
      "title": "Bariki",
      "balance": "Available",
      "equals": "bariki ≈ {{amount}} ֏ · 1 bariki = 1 ֏",
      "pending": "pending: {{amount}}, available from {{date}}",
      "burn": "{{amount}} expire on {{date}} — any order keeps them",
      "pay": "Pay with bariki",
      "enterCode": "Enter a code",
      "requestPending": "Your bariki payment request is waiting for approval.",
      "rates": "Cashback by category",
      "plusWouldGet": "With Barev+ you’d have +{{amount}} more bariki over the last 30 days →",
      "streak": "Cleaning streak",
      "streakLeft": "{{left}} more and cleaning cashback goes +{{bonus}}%. Keep gaps under {{days}} days.",
      "streakMax": "Top streak: +{{bonus}}% cashback on every cleaning.",
      "route": "First-month route",
      "routeText": "Book services from 3 different categories by {{date}} and get {{amount}} bariki. Now: {{done}} of 3.",
      "history": "History",
      "empty": "You earn bariki on every paid order — cashback at your level’s rate.",
      "availableFrom": "available from {{date}}",
      "until": "until {{date}}",
      "payHint": "Bariki can cover up to {{pct}}% of an order, minimum {{min}}. The team will confirm and send the amount left to pay.",
      "forOrder": "Order",
      "otherOrder": "Another order (not in the app)",
      "amount": "How many bariki to use",
      "max": "Maximum: {{max}}",
      "note": "Comment",
      "notePh": "Which order and for how much",
      "send": "Send request",
      "requested": "Request sent — we’ll reply in the chat.",
      "useInOrder": "Use {{amount}} bariki",
      "useHint": "up to {{pct}}% of the order · balance {{balance}}",
      "notWithPromo": "Not together with a promo code",
      "belowMin": "Minimum {{min}} · balance {{balance}}",
      "paidLine": "Paid with bariki",
      "type": {
        "accrual": "Cashback",
        "bonus": "Bonus",
        "redemption": "Paid with bariki",
        "request": "Payment request",
        "reversal": "Reversal"
      },
      "status": {
        "PENDING": "pending",
        "ACTIVE": "available",
        "SPENT": "spent",
        "EXPIRED": "expired",
        "REVERSED": "reversed",
        "REQUESTED": "awaiting approval",
        "CONFIRMED": "redeemed",
        "REJECTED": "declined",
        "ACCRUAL": "credit reversed",
        "REDEMPTION": "bariki returned"
      }
    }
  },
  "pro": {
    "nav": {
      "label": "Navigation",
      "today": "Today",
      "history": "History",
      "company": "Company",
      "partner": "Partner"
    },
    "openInTelegram": {
      "title": "Open in Telegram",
      "text": "The specialist cabinet opens from the Barev Pro bot."
    },
    "notLinked": {
      "title": "Account not linked",
      "text": "Ask the operator for an invite link and open it in Telegram."
    },
    "today": {
      "onShift": "On shift",
      "offShift": "Off shift",
      "earned": "Earned",
      "orders": "Orders",
      "rating": "Rating",
      "now": "Now",
      "open": "Open order",
      "title": "Today's orders",
      "empty": "No orders today.",
      "upcoming": "Coming up"
    },
    "offer": {
      "title": "New order",
      "accept": "Accept",
      "decline": "Decline",
      "accepted": "Order accepted",
      "declined": "You declined the order",
      "left": "left"
    },
    "action": {
      "depart": "On my way",
      "arrived": "I've arrived",
      "startCleaning": "Start cleaning",
      "finishCleaning": "Finish and send photos",
      "startWork": "Start work",
      "closeRepair": "Close order",
      "atPickup": "I'm at the airport",
      "passengerIn": "Passenger on board",
      "finishRide": "Finish ride",
      "scheduleLesson": "Schedule lesson",
      "openLesson": "Open lesson",
      "startLesson": "Start",
      "finishLesson": "Finish lesson",
      "openMeeting": "Open meeting",
      "startMeeting": "Start",
      "finishMeeting": "Finish"
    },
    "job": {
      "when": "When",
      "where": "Where",
      "client": "Client",
      "clientLanguage": "language",
      "price": "Amount",
      "checklist": "Checklist",
      "checklistFirst": "To finish, tick every checklist item and attach a photo.",
      "takePhoto": "Take photo",
      "retakePhoto": "Retake",
      "confirmFinish": "Finish the order? The client will get a notification and the photo report.",
      "markPaid": "Client has paid",
      "confirmPaid": "Confirm the client paid {{amount}}?",
      "paidMarked": "Payment recorded"
    },
    "history": {
      "title": "History",
      "week": "7 days",
      "month": "This month",
      "prevMonth": "Last month",
      "earned": "Earned",
      "done": "Completed",
      "empty": "No orders in this period.",
      "ratePercent": "Rate: {{value}}% of the order",
      "rateFixed": "Rate: {{value}} per order",
      "ratePreset": "Rate: “{{name}}” preset",
      "ratePartner": "Your company sets your pay for orders"
    },
    "company": {
      "title": "Company",
      "pending": "Waiting to be assigned",
      "noPending": "All orders are assigned.",
      "assign": "Assign a team member",
      "chooseStaff": "Who takes the order",
      "assigned": "Assigned",
      "noAssigned": "Nothing yet.",
      "assigned_ok": "Team member assigned",
      "staff": "Team",
      "notLinked": "not in the bot",
      "free": "free",
      "busy": "busy",
      "speaksLanguage": "client's language",
      "load_one": "{{count}} order that day",
      "load_few": "{{count}} orders that day",
      "load_many": "{{count}} orders that day",
      "load_other": "{{count}} orders that day"
    },
    "partner": {
      "owner": "owner",
      "staff": "staff",
      "visits30_one": "{{count}} check in 30 days",
      "visits30_few": "{{count}} checks in 30 days",
      "visits30_many": "{{count}} checks in 30 days",
      "visits30_other": "{{count}} checks in 30 days",
      "scan": "Scan client QR",
      "scanSub": "Shows the client level and what they get",
      "scanHint": "Point the camera at the QR in the client app",
      "noScanner": "The scanner works only inside Telegram. You can type the code instead.",
      "manual": "Or paste the code / link from the QR",
      "check": "Check",
      "valid": "{{name}} — {{level}}",
      "until": "subscription until {{date}}",
      "needLevel": "needs {{level}}",
      "unlimited": "no limit",
      "redeemed": "Redeemed: {{offer}}",
      "offers": "Your club offers",
      "noOffers": "No offers yet.",
      "offersHint": "To change offers, message the club operator.",
      "allMembers": "all members",
      "limit_ONCE": "first visit only",
      "limit_WEEK": "{{count}}× a week",
      "limit_MONTH": "{{count}}× a month",
      "team": "Team",
      "invite": "Invite",
      "inviteQr": "Staff invite QR",
      "inviteHint": "The staff member scans this QR with their phone camera and presses Start. Single-use, valid until {{time}}.",
      "inviteLink": "Or send the link",
      "remove": "Remove",
      "removeConfirm": "Remove {{name}} from the team?",
      "recent": "Recent checks",
      "noRecent": "No checks yet.",
      "checked": "card check"
    },
    "web": {
      "loginHint": "Open the work bot and tap “Open on a computer” (or send /web) — you’ll get a login link."
    },
    "cab": {
      "tab": {
        "orders": "Orders",
        "staff": "Staff",
        "money": "Income",
        "settings": "Settings"
      },
      "autoOn": "Auto-assignment is on: new orders go to free staff automatically.",
      "income": "Your income",
      "deadline": "assign by {{time}}",
      "offeredTo": "waiting for {{name}}",
      "decline": "Decline",
      "declineConfirm": "Decline this order? It will go back to Barev Club.",
      "declined": "Order returned",
      "reassign": "Reassign",
      "unassignConfirm": "Remove {{name}} from the order? It will wait for assignment again.",
      "unassigned": "Staff member removed",
      "gapHint": "Travel gap between orders: {{min}} min.",
      "noStaff": "No staff yet — add them in the “Staff” tab.",
      "dayLoad": "that day {{n}}/{{max}}",
      "weekLoad": "this week {{n}}",
      "district": "district",
      "check": {
        "ok": "Free",
        "busy": "Busy",
        "gap": "No time to travel",
        "limit": "Daily limit",
        "notLinked": "Not in the bot",
        "gap_confirm": "There’s less travel time between orders than set. Assign anyway?",
        "limit_confirm": "This person has reached their daily order or hour limit. Assign anyway?",
        "notLinked_confirm": "This person hasn’t joined the work bot yet and won’t be notified. Assign?",
        "busy_confirm": "This person is busy at that time."
      },
      "addStaff": "Add staff member",
      "todayLoad": "today {{n}}/{{max}}",
      "hoursMax": "up to {{n}} h a day",
      "off": "off",
      "staffAdded": "Staff member added",
      "saved": "Saved",
      "inviteText": "Send this link to the staff member: they’ll open the work bot and can take orders.",
      "done": "Done",
      "f": {
        "name": "Name",
        "phone": "Phone",
        "languages": "Languages",
        "districts": "Districts (empty — any)",
        "days": "Working days",
        "from": "From",
        "to": "To",
        "maxOrders": "Max orders a day",
        "maxHours": "Max hours a day",
        "loadHint": "Empty means no limit. Auto-assignment won’t give the person more."
      },
      "save": "Save",
      "resetInvite": "New login link",
      "resetConfirm": "Make a new link? The current bot login will be disconnected.",
      "turnOff": "Turn off",
      "turnOn": "Turn on",
      "offConfirm": "Turn off {{name}}? They won’t get new orders.",
      "copy": "Copy",
      "copied": "Copied",
      "balance": "To be paid",
      "accrued": "Accrued",
      "paidOut": "Paid out",
      "terms": {
        "COMMISSION": "Terms: Barev Club takes {{pct}}% of each paid order, the rest is yours. Wages and costs are yours.",
        "PROFIT_SHARE": "Terms: Barev Club pays the cleaner ({{fot}}%) and tax ({{tax}}%); you get {{pct}}% of what’s left."
      },
      "byMonth": "By month",
      "ordersN": "orders: {{n}}",
      "byOrder": "By order",
      "noIncome": "Income appears once a client pays for a completed order.",
      "paidBy": "paid {{sum}}",
      "minus": "−payroll {{fot}}, −tax {{tax}}, your {{pct}}%",
      "minusCommission": "−{{pct}}% Barev Club",
      "payouts": "Payouts",
      "payout": {
        "paid": "paid",
        "pending": "pending"
      },
      "auto": "Auto-assignment",
      "autoHint": "A new order is offered to the best free staff member: free by schedule, has time to travel, within limits; preferred — speaks the client’s language, works in the district, fewer orders this week, higher rating. If they decline or don’t answer, it goes to the next.",
      "gap": "Travel gap between orders, min",
      "gapMin": "At least {{min}} min",
      "timeoutHint": "If an order isn’t assigned within {{min}} min, it goes back to Barev Club.",
      "managers": "Managers",
      "you": "you",
      "remove": "Remove",
      "removeManagerConfirm": "Remove {{name}} from managers?",
      "managerInvite": "Link for another manager — they open the work bot and get access to the cabinet:",
      "logout": "Log out on this computer",
      "wd": {
        "0": "Mon",
        "1": "Tue",
        "2": "Wed",
        "3": "Thu",
        "4": "Fri",
        "5": "Sat",
        "6": "Sun"
      }
    }
  },
  "bot": {
    "client": {
      "chooseLanguage": "Выбери язык · Choose your language · 选择语言 · Ընտրեք լեզուն · Elige tu idioma",
      "languageSet": "Language: {{language}}",
      "fromAgency": "Hi! You came from real estate agency {{agency}} — we have a gift for you.",
      "consentText": "To use Barev Club we need your consent to process personal data. It goes to the specialist doing your order and the partners listed in the policy, and is stored on a server in Germany.\n\n<a href=\"{{url}}\">Privacy policy</a>",
      "consentAccept": "I agree",
      "giftActivated": "🎁 A gift from your real estate agency: {{plan}} is active until {{date}}. Service discounts already apply.",
      "welcome": "Yerevan feels like home. From day one.\n\nBook cleaning and other services, track the status and enjoy partner discounts — all in the app.",
      "openApp": "Open app",
      "enterCode": "Enter real estate agency code",
      "changeLanguage": "Change language",
      "codePrompt": "Send the real estate agency code from your lease.",
      "codeAccepted": "Code accepted: {{agency}}.",
      "help": "Tap “Open app” to book a service. Commands: /app — the app, /code — real estate agency code, /language — language.",
      "cmdStart": "Start",
      "cmdApp": "Open app",
      "cmdCode": "Enter real estate agency code",
      "cmdLanguage": "Change language",
      "cmdHelp": "Help",
      "webRequestOrdered": "Request No. {{request}} received and booked as order No. {{order}} for {{date}}. Track the status in the app.",
      "webRequestLinked": "Request No. {{request}} received. An operator will contact you to confirm the time.",
      "conciergeReceived": "Passed to the concierge — we'll reply here, in this chat.",
      "supportReceived": "Passed to support — we'll reply here, in this chat.",
      "channelSupport": "You are now writing to support. Just send a message, photo or file.",
      "channelConcierge": "You are now writing to your personal concierge. Just send a message, photo or file.",
      "cmdSupport": "Write to support",
      "cmdConcierge": "Write to the concierge (Barev+)",
      "rated": "Thanks for your rating! {{stars}}",
      "ratedLow": "Sorry it didn’t go well. Tell us here what happened — the team will sort it out.",
      "wr": {
        "intro": "We have your request #{{request}}. Just a couple of questions to book it.",
        "askDistrict": "Which district is the apartment in?",
        "askAddress": "Send the address: street, building, apartment.",
        "askDay": "When suits you? Pick a day.",
        "askTime": "Pick a time on {{day}}:",
        "dayFull": "That day is fully booked. Please pick another day.",
        "noSlots": "No free time in the coming days — an operator will contact you to find a slot."
      },
      "cmdBalance": "Bariki balance",
      "cmdHistory": "Bariki history",
      "points": {
        "balance": "🪙 Bariki: {{balance}} (≈ {{balance}} ֏)",
        "pending": "⏳ Pending: {{pending}}, available from {{date}}",
        "burn": "🔥 Expire on {{date}} if there are no orders",
        "empty": "No bariki activity yet.",
        "open": "Open bariki",
        "type": {
          "accrual": "Cashback",
          "bonus": "Bonus",
          "redemption": "Paid with bariki",
          "request": "Payment request",
          "reversal": "Reversal"
        },
        "status": {
          "PENDING": "pending",
          "ACTIVE": "available",
          "SPENT": "spent",
          "EXPIRED": "expired",
          "REVERSED": "reversed",
          "REQUESTED": "awaiting approval",
          "CONFIRMED": "redeemed",
          "REJECTED": "declined",
          "ACCRUAL": "credit reversed",
          "REDEMPTION": "bariki returned"
        }
      }
    },
    "pro": {
      "notLinked": "This bot is for Barev Club specialists. Ask the operator for an invite link.",
      "linkedProvider": "Done, {{name}}! Your account is linked.",
      "linkedDispatcher": "Done! You're the dispatcher for “{{name}}”.",
      "youAreProvider": "{{name}} · {{role}}",
      "youAreDispatcher": "Dispatcher for “{{company}}”",
      "welcome": "New orders arrive here. Accept them with the buttons in the message and manage your day in the cabinet.",
      "openCabinet": "Open cabinet",
      "messageReceived": "Passed to the operator — the reply will come here.",
      "openWeb": "💻 Open on a computer",
      "webLink": "Link to the cabinet for your browser (single use, valid for 15 minutes):\n{{url}}"
    },
    "admin": {
      "hello": "{{name}}, Barev Club admin notifications arrive here.",
      "linked": "Done, {{name}}! Admin notifications will arrive here. Reply to clients with the “Reply” button.",
      "linkInvalid": "The link has expired — press “Connect Telegram” in the admin again.",
      "notAdmin": "This Telegram isn’t connected to the admin.",
      "open": "Open in admin",
      "reply": "Reply",
      "replyPrompt": "Reply to {{name}} — type a message. /cancel to cancel.",
      "replyPlaceholder": "Reply text",
      "replySent": "Sent: {{name}}",
      "replyCancelled": "Reply cancelled.",
      "provider": "provider",
      "newOrder": "New order #{{number}}",
      "newLead": "Relocation request #{{number}}",
      "newRequest": "App request #{{number}}",
      "newWebRequest": "Site request #{{number}}",
      "loginOk": "Sign-in confirmed — go back to your browser.",
      "loginExpired": "The sign-in link has expired — reload the admin page.",
      "channelSupport": "Support",
      "channelConcierge": "Concierge",
      "file": "file",
      "chatAssigned": "{{by}} passed you a conversation: {{name}}",
      "order": "Order #{{number}}",
      "noOrder": "No current order",
      "autoFailed": "No free provider found for order #{{number}} — please assign manually.",
      "partnerDeclined": "Partner “{{partner}}” declined order #{{number}} — reassign it",
      "partnerExpired": "Partner “{{partner}}” didn’t assign staff to order #{{number}} in time — reassign it",
      "noTime": "no time given",
      "noAddress": "no address given",
      "points": {
        "forOrder": "Order #{{number}} for {{sum}}",
        "confirm": "✅ Confirm",
        "reject": "Decline",
        "request": "Client asks to pay with bariki: {{amount}}",
        "balance": "balance {{balance}}",
        "suggestions": "New bariki suggestions: {{count}} ({{open}} in the queue)",
        "overLimit": "{{by}} wants to process {{amount}} bariki — above the limit, needs your approval",
        "mismatch": "Bariki reconciliation: {{count}} clients had a mismatched balance — fixed, check the log",
        "confirmed": "Redeemed {{amount}} bariki",
        "rejected": "Request declined",
        "help": "Credit for an order: /barik <phone or @username> <order amount> [category]\nCategories: cleaning, documents, learning, repair, transfer",
        "noClient": "Client not found",
        "preview": "Credit {{amount}} bariki to {{name}} for {{what}} {{sum}} ֏ ({{tier}}, {{rate}}%). Available from {{date}}.",
        "accrue": "🪙 Credit",
        "done": "Credited {{amount}} bariki",
        "needsApproval": "Above the limit — sent to a super admin for approval",
        "zero": "The amount is 0 — nothing to credit"
      },
      "pay": {
        "subscription": "{{plan}} membership",
        "order": "Order #{{number}} · {{service}}",
        "paid": "Online payment",
        "renewed": "Membership renewed",
        "refunded": "Online payment refunded",
        "cancelled": "Auto-renewal stopped",
        "attention": "Payment needs attention",
        "attentionHint": "The client paid online, but the order was already paid or cancelled — refund it in Tribute.",
        "fromSite": "Paid on the website (Telegram not linked yet)"
      }
    },
    "partner": {
      "valid": "{{name}} — {{level}}, card is valid",
      "until": "subscription until {{date}}",
      "needLevel": "needs {{level}}",
      "noOffers": "No offers yet — message the club operator.",
      "notPartner": "This is a Barev Club card. Only club partners can check it.",
      "redeem": "Redeem",
      "redeemed": "Redeemed",
      "redeemedText": "Redeemed: {{offer}}",
      "linkedOwner": "Done! You are the owner of “{{partner}}”. Open the cabinet: offers, staff and the QR scanner.",
      "linkedStaff": "Done! You are on the “{{partner}}” team. Scan client QR codes with the camera or in the cabinet.",
      "youAreOwner": "Owner of “{{partner}}”",
      "youAreStaff": "Staff at “{{partner}}”",
      "left_ONCE": "first visit",
      "left_WEEK": "left this week: {{count}}",
      "left_MONTH": "left this month: {{count}}",
      "used_ONCE": "already used",
      "used_WEEK": "already used this week",
      "used_MONTH": "already used this month"
    }
  },
  "notify": {
    "openOrder": "Open order",
    "duration": "{{minutes}} min",
    "clientLanguage": "Client's language",
    "created": "Order received: {{when}}. Total {{total}}. We'll let you know once a specialist is assigned.",
    "rescheduled": "Order moved to {{when}}.",
    "reminder24": "Reminder: tomorrow, {{when}}.",
    "reminder1": "In one hour: {{when}}.",
    "event": {
      "arrived": "Your specialist has arrived.",
      "openLesson": "Your lesson is about to start.",
      "openMeeting": "Your meeting is about to start."
    },
    "status": {
      "CLEANING": {
        "NEW": "Looking for a new cleaner for {{when}}.",
        "ASSIGNED": "Cleaner {{provider}} is assigned for {{when}}.",
        "EN_ROUTE": "Cleaner {{provider}} is on the way.",
        "CLEANING": "Cleaning has started.",
        "DONE": "Cleaning is done. The photo report is in the app.",
        "CANCELLED": "Order cancelled."
      },
      "REPAIR": {
        "NEW": "Looking for a handyman for {{when}}.",
        "ASSIGNED": "Handyman {{provider}} is assigned for {{when}}.",
        "ON_SITE": "The handyman is on site and preparing an estimate.",
        "ESTIMATE_APPROVED": "Estimate approved.",
        "REPAIRING": "Repairs have started.",
        "DONE": "Repairs are done.",
        "CANCELLED": "Order cancelled."
      },
      "TRANSFER": {
        "NEW": "Looking for a driver for {{when}}.",
        "ASSIGNED": "Driver {{provider}} is assigned for {{when}}.",
        "DRIVER_WAITING": "Your driver is waiting.",
        "RIDE_IN_PROGRESS": "Your ride has started.",
        "COMPLETED": "Ride completed.",
        "CANCELLED": "Order cancelled."
      },
      "LANGUAGE": {
        "ENROLLED": "You're enrolled in the course.",
        "LESSON_SCHEDULED": "Lesson scheduled: {{when}}.",
        "LESSON_IN_PROGRESS": "Your lesson has started.",
        "LESSON_DONE": "Lesson finished.",
        "COMPLETED": "Lesson pack completed!",
        "CANCELLED": "Order cancelled."
      },
      "CAREER": {
        "NEW": "Looking for a coach.",
        "CONSULTANT_ASSIGNED": "Coach {{provider}} is assigned.",
        "RESUME_RECEIVED": "CV received.",
        "MEETING": "Your meeting has started.",
        "PLAN_SENT": "Your job-search plan is ready.",
        "CANCELLED": "Order cancelled."
      },
      "DOCUMENTS": {
        "NEW": "Request received.",
        "DOCS_REVIEW": "We're checking your documents.",
        "NEEDS_MORE_DOCS": "More documents are needed — details in the app.",
        "SUBMITTED": "Documents submitted.",
        "DONE": "Your document is ready!",
        "CANCELLED": "Order cancelled."
      }
    },
    "pro": {
      "offerTitle": "A new order for you",
      "offerTimeout": "Reply within {{minutes}} min, or the order goes to another specialist.",
      "assignedByDispatcher": "The dispatcher assigned you an order for {{when}}.",
      "cancelled": "The order for {{when}} was cancelled.",
      "rescheduled": "Order moved to {{when}}.",
      "unassigned": "The order for {{when}} was taken off you.",
      "reminder24": "Order tomorrow: {{when}}.",
      "reminder1": "Order in one hour: {{when}}.",
      "orderEdited": "The order on {{when}} was updated — please open it."
    },
    "dispatcher": {
      "newOrder": "New order for the company for {{when}}. Assign a team member in the cabinet.",
      "returned": "A team member declined the order for {{when}}. Assign someone else.",
      "noStaff": "No free staff for the order on {{when}} — assign manually in the cabinet.",
      "expired": "The order on {{when}} went back to Barev Club: no one was assigned in time."
    },
    "openPlan": "Open the app",
    "concierge": "Barev Club concierge",
    "subscriptionActivated": "{{plan}} is on until {{date}}. Discounts are already in service prices.",
    "operator": "Barev Club operator",
    "support": "Barev Club support",
    "rateAsk": "How did it go? Please rate — it takes a second:",
    "points": {
      "open": "My bariki",
      "pending": "🪙 +{{amount}} bariki for {{what}} on {{date}}. Available from {{available}}.",
      "active": "🪙 +{{amount}} bariki for {{what}}. Balance: {{balance}}.",
      "bonus": "🎁 +{{amount}} bariki as a gift: {{what}}. Valid until {{until}}.",
      "bonusNoTtl": "🎁 +{{amount}} bariki as a gift: {{what}}.",
      "housewarming": "a housewarming gift from {{agency}}",
      "activated": "✅ {{amount}} bariki are now available. Balance: {{balance}}.",
      "redeemed": "Paid with bariki: {{amount}}. Left to pay: {{due}}. Balance: {{balance}}.",
      "redeemedNoOrder": "Bariki redeemed: {{amount}}. Balance: {{balance}}.",
      "requestExpired": "Your bariki payment request expired. Send a new one if needed.",
      "rejected": "Your bariki payment request was declined: {{reason}}",
      "declinedGeneric": "message us in the chat and we’ll sort it out.",
      "orderCancelled": "the order was cancelled",
      "returned": "↩️ {{amount}} bariki are back on your balance. Balance: {{balance}}.",
      "reversed": "The credit {{what}} was reversed: {{reason}}. Balance: {{balance}}.",
      "expiring": "⏰ {{amount}} bariki expire in {{days}} days. Any order keeps them.",
      "expired": "{{amount}} bariki expired after a long time without orders.",
      "orderEdited": "the order changed — we’ll credit the new amount"
    },
    "orderEdited": "Your order was updated. Total to pay: {{total}}."
  },
  "admin": {
    "nav": {
      "orders": "Orders",
      "clients": "Clients",
      "providers": "Specialists",
      "companies": "Service partners",
      "services": "Services & prices",
      "agencies": "Real estate agencies",
      "settings": "Settings",
      "presets": "Rates",
      "webRequests": "Website requests",
      "leads": "Relocation",
      "concierge": "Concierge",
      "requests": "App requests",
      "partners": "Club partners",
      "telegram": "Notifications",
      "templates": "Moving templates"
    },
    "roles": {
      "OWNER": "Owner",
      "OPERATOR": "Operator"
    },
    "logout": "Sign out",
    "save": "Save",
    "saved": "Saved",
    "edit": "Edit",
    "add": "Add",
    "active": "Active",
    "copy": "Copy",
    "copied": "Copied",
    "login": {
      "title": "Admin sign-in",
      "email": "Login or email",
      "password": "Password",
      "submit": "Sign in",
      "totpTitle": "Verification code",
      "setupTitle": "Set up 2FA",
      "setupText": "Scan the QR code with an authenticator app (Google Authenticator, 1Password) and enter the code.",
      "qrAlt": "QR code for the authenticator app",
      "code": "Code from the app",
      "verify": "Verify"
    },
    "summary": {
      "ordersToday": "Orders today",
      "unassigned": "Unassigned",
      "revenueToday": "Revenue today",
      "freeProviders": "Free / on shift"
    },
    "kanban": {
      "title": "Orders",
      "category": "Category",
      "allCategories": "All categories",
      "service": "Service",
      "allServices": "All services",
      "date": "Date",
      "search": "Search: #, name, address",
      "showCancelled": "Cancelled",
      "newOrderTitle": "New order",
      "awaiting": "Awaiting reply: {{name}}",
      "toCompany": "Assigned to company: {{name}}",
      "col": {
        "new": "New",
        "assigned": "Assigned",
        "in_progress": "In progress",
        "done": "Done",
        "cancelled": "Cancelled"
      }
    },
    "order": {
      "when": "When",
      "min": "min",
      "params": "Details",
      "address": "Address",
      "note": "Note",
      "client": "Client",
      "agency": "agency",
      "provider": "Specialist",
      "price": "Price",
      "cancelFee": "fee",
      "payment": "Payment",
      "actions": "Actions",
      "comment": "Comment for the action",
      "unassign": "Unassign",
      "confirmUnassign": "Unassign the specialist? The order goes back to “New”.",
      "markPaid": "Mark as paid",
      "confirmPaid": "Mark {{amount}} as received?",
      "cancel": "Cancel order",
      "confirmCancel": "Cancel the order? The client will be notified.",
      "checklist": "Checklist",
      "photo": "Photo",
      "history": "History",
      "offers": "Offers",
      "assignTitle": "Assignment",
      "assignTo": "Assign: {{name}}",
      "assign": "Assign",
      "company": "company",
      "noCandidates": "No free specialists at this time.",
      "chooseManually": "Choose manually ({{count}})",
      "hideOthers": "Hide",
      "busy": "Busy",
      "load_one": "{{count}} order that day",
      "load_few": "{{count}} orders that day",
      "load_many": "{{count}} orders that day",
      "load_other": "{{count}} orders that day",
      "offered": "Order sent to the specialist",
      "statusChanged": "Status changed",
      "cancelled": "Order cancelled",
      "unassigned": "Specialist unassigned",
      "paid": "Payment recorded"
    },
    "reasons": {
      "language": "client's language",
      "district": "district",
      "onShift": "on shift",
      "lowLoad": "free day"
    },
    "actors": {
      "CLIENT": "client",
      "PROVIDER": "specialist",
      "DISPATCHER": "dispatcher",
      "ADMIN": "operator",
      "SYSTEM": "system"
    },
    "offerStatus": {
      "OFFERED": "awaiting reply",
      "ACCEPTED": "accepted",
      "DECLINED": "declined",
      "EXPIRED": "expired",
      "REVOKED": "revoked"
    },
    "events": {
      "accepted": "Specialist accepted",
      "dispatcherAssigned": "Dispatcher assigned a team member",
      "assignedToCompany": "Passed to company",
      "offerDeclined": "Specialist declined",
      "offerExpired": "Reply time expired",
      "rescheduled": "Rescheduled",
      "unassigned": "Specialist unassigned",
      "depart": "On the way",
      "arrived": "Arrived",
      "startCleaning": "Started cleaning",
      "finishCleaning": "Finished cleaning",
      "startWork": "Started work",
      "closeRepair": "Closed the order",
      "atPickup": "Driver at pickup",
      "passengerIn": "Passenger on board",
      "finishRide": "Ride finished",
      "scheduleLesson": "Lesson scheduled",
      "openLesson": "Lesson opened",
      "startLesson": "Lesson started",
      "finishLesson": "Lesson finished",
      "openMeeting": "Meeting opened",
      "startMeeting": "Meeting started",
      "finishMeeting": "Meeting finished",
      "editedByStaff": "Composition changed by the team",
      "checklistByStaff": "Checklist item checked by the team",
      "checklistUncheckedByStaff": "Checklist item unchecked by the team"
    },
    "weekdays": {
      "0": "Mon",
      "1": "Tue",
      "2": "Wed",
      "3": "Thu",
      "4": "Fri",
      "5": "Sat",
      "6": "Sun"
    },
    "schedule": {
      "from": "From",
      "to": "To",
      "works": "Working day"
    },
    "rate": {
      "PERCENT": "% of order",
      "FIXED": "Fixed per order"
    },
    "providers": {
      "add": "Add specialist",
      "name": "Name",
      "phone": "Phone",
      "role": "Role",
      "company": "Company",
      "freelancer": "Freelancer",
      "languages": "Languages",
      "districts": "Districts",
      "rate": "Rate",
      "rateType": "Rate type",
      "ratePercent": "Percent of order",
      "rateFixed": "Amount per order, ֏",
      "companyRate": "company rate",
      "rating": "Rating",
      "schedule": "Schedule",
      "telegram": "Telegram",
      "linked": "linked",
      "resetInvite": "New invite link",
      "preset": "Rate",
      "ownRate": "Individual rate"
    },
    "companies": {
      "add": "Add company",
      "name": "Name",
      "phone": "Contact phone",
      "roles": "Order types",
      "employees": "Team",
      "dispatchers": "Dispatchers",
      "dispatcherInvite": "Dispatcher invite link"
    },
    "services": {
      "plusDiscount": "Barev+ discount",
      "active": "available",
      "inactive": "hidden",
      "availableToOrder": "Available to order",
      "prices": "Prices and duration",
      "variant": "Variant",
      "base": "Price for 1 room, ֏",
      "perRoom": "Each extra room, ֏",
      "baseMinutes": "Minutes for 1 room",
      "perRoomMinutes": "Minutes per extra room",
      "price": "Price, ֏",
      "minutes": "Duration, min",
      "lateFee": "Late cancellation fee, %",
      "step": "Slot step, min",
      "dayStart": "Day starts, h",
      "dayEnd": "Day ends, h",
      "leadHours": "Minimum hours before start",
      "horizon": "Bookable days ahead",
      "perBathroom": "Each extra bathroom, ֏",
      "perBathroomMinutes": "Minutes per bathroom",
      "extras": "Extra services",
      "extra": "Service",
      "extraPrice": "Price, ֏",
      "extraMinutes": "Minutes per unit",
      "eliteDiscount": "Elite discount"
    },
    "agencies": {
      "add": "Add real estate agency",
      "name": "Name",
      "code": "Code",
      "commission": "Reward, %",
      "contact": "Contact",
      "leads": "Leads",
      "links": "QR links",
      "bot": "Straight to the bot",
      "landing": "Via the landing page",
      "hint": "A client stays attached to the agency for {{months}} months from their first visit. Rewards count only on paid orders."
    },
    "clients": {
      "name": "Client",
      "language": "Language",
      "source": "Source",
      "membership": "Membership",
      "orders": "Orders",
      "since": "Joined",
      "noConsent": "no consent",
      "source_organic": "Organic",
      "source_deeplink": "Agency link",
      "source_manual_code": "Manual code",
      "grant": "+30 days Barev+",
      "grantConfirm": "Grant this client 30 days of Barev+?",
      "grantElite": "Elite for 30 days",
      "grantEliteConfirm": "Give this client Barev Elite for 30 days?",
      "segment_MOVING": "moving",
      "segment_LIVING": "lives in Armenia"
    },
    "settings": {
      "cancel_freeHours": "Free cancellation up to, h before",
      "agency_attributionMonths": "Client attached to agency, months",
      "agency_defaultCommissionPct": "Default agency reward, %",
      "barevPlus_giftDays": "Landing: “first N days free” (the gift itself is set per agency)",
      "barevPlus_monthlyPrice": "Barev+ monthly price, ֏",
      "offer_acceptTimeoutMinutes": "Specialist reply time, min",
      "chat_closeAfterHours": "Chat closes after the order, h",
      "files_retentionDays": "Keep document scans, days",
      "consent_version": "Privacy policy version",
      "paymentMethods": "Payment methods",
      "code": "Code",
      "name": "Name",
      "admins": "Administrators",
      "role": "Role",
      "tempPassword": "Temporary password (10+ characters)",
      "addAdmin": "Add administrator",
      "disable": "Disable",
      "enable": "Enable",
      "barevPlus_maxDiscountPct": "Barev+: discount up to, %",
      "elite_monthlyPrice": "Barev Elite: monthly price, ֏",
      "elite_maxDiscountPct": "Barev Elite: discount up to, %",
      "relocation_hotelWithPlus": "Home page: hotel with Barev+, ֏/night",
      "relocation_hotelBase": "Home page: hotel without subscription, ֏/night",
      "relocation_consultation": "Home page: relocation consultation, ֏",
      "docs_fromPrice": "/live: documents “from”, ֏",
      "docs_socialCardPrice": "Social card, turnkey, AMD",
      "residence_escortFrom": "Residence permit: support from, AMD",
      "residence_stateFee": "Residence permit: state fee (1 year), AMD",
      "transfer_standardPrice": "Transfer “Standard”, AMD",
      "transfer_premiumPrice": "Transfer “Premium”, AMD",
      "assign_auto": "Assign orders automatically",
      "assign_maxAutoOffers": "How many providers to try automatically",
      "sales_bonusPerVenue": "Sales bonus per venue, ֏",
      "sales_bonusPerAgency": "Sales bonus per agency, ֏",
      "sales_bonusAgencyPct": "Sales bonus: % of revenue from their agencies’ clients",
      "sales_bonusAgencyMonths": "…for how many months after the agency joins",
      "partner_fotPct": "Partners (our costs): cleaner payroll, % of order",
      "partner_taxPct": "Partners (our costs): tax, %",
      "partner_minTravelGapMinutes": "Partners: minimum gap between a staff member’s orders, min",
      "partner_acceptTimeoutMinutes": "Partners: minutes to assign staff before the order comes back",
      "points_pendingHours": "Bariki: available N hours after the service",
      "points_maxSharePct": "Bariki: up to N% of an order",
      "points_minRedeem": "Bariki: minimum per redemption",
      "points_burnDays": "Bariki: expire after N days of inactivity",
      "points_warnDays1": "Bariki: first warning N days before",
      "points_warnDays2": "Bariki: second warning N days before",
      "points_requestTtlHours": "Bariki: client request waits N hours",
      "points_streakGapDays": "Bariki: cleaning streak — gap of up to N days",
      "points_diffHighlightPct": "Bariki: highlight manual amounts off by more than N%",
      "points_supportCanManage": "Support can also credit and redeem bariki (with limits)",
      "points_opMaxPerOperation": "Support limit per operation, bariki",
      "points_opMaxPerDay": "Support daily limit, bariki",
      "barevPlus_monthlyPriceEur": "Barev+: monthly price for online payment, €",
      "elite_monthlyPriceEur": "Barev Elite: monthly price for online payment, €",
      "fx_eurAmd": "Rate: ֏ per €1 (orders converted to euros)",
      "fx_eurRub": "Rate: ₽ per €1 (“≈ ₽” hint for clients)"
    },
    "presets": {
      "add": "Add preset",
      "hint": "A preset sets the cleaner’s pay for every price line: a fixed amount in AMD or a percentage. Percentages are taken from the price before the Barev+ discount. Assign a preset in the specialist’s card.",
      "providers_one": "{{count}} specialist",
      "providers_few": "{{count}} specialists",
      "providers_many": "{{count}} specialists",
      "providers_other": "{{count}} specialists",
      "room": "Each extra room",
      "bathroom": "Each extra bathroom",
      "name": "Preset name",
      "applyAll": "One percentage for all",
      "line": "Price line",
      "type": "Type",
      "value": "Value",
      "percent": "% of the line",
      "fixed": "Fixed {{unit}}",
      "perOrder": "per order",
      "perRoom": "per room",
      "perBathroom": "per bathroom"
    },
    "webRequests": {
      "all": "All",
      "status_NEW": "Bot not opened",
      "status_LINKED": "Call needed",
      "status_ORDERED": "Order created",
      "status_CANCELLED": "Cancelled",
      "number": "No.",
      "when": "Preferred time",
      "what": "Cleaning",
      "contact": "Contact",
      "address": "Address",
      "price": "Price",
      "status": "Status",
      "note": "Operator note",
      "notePlaceholder": "Called, call back…",
      "saveNote": "Save",
      "cancel": "Cancel",
      "cancelConfirm": "Cancel request No. {{number}}?",
      "reopen": "Reopen",
      "order": "Order No. {{number}}",
      "created": "Created {{date}}",
      "empty": "No requests yet. They appear here as soon as someone fills in the form at barevclub.com/clean."
    },
    "leads": {
      "title": "Relocation requests",
      "all": "All",
      "empty": "No quiz requests yet.",
      "number": "#",
      "contact": "Contact",
      "plan": "When",
      "package": "Package",
      "status": "Status",
      "note": "Note",
      "created": "created {{date}}",
      "unfinished": "didn't finish the quiz",
      "moved": "already lives in Armenia",
      "status_NEW": "New",
      "status_IN_WORK": "In progress",
      "status_DONE": "Done",
      "status_CANCELLED": "Cancelled",
      "budget": "{{from}}–{{to}} ֏/night",
      "inApp": "in the app",
      "stepNote": "Note for the client",
      "stepsInApp": "Moving plan — the client sees the steps in the app and gets a message on each status change",
      "stepsNoApp": "Moving plan — the client hasn't opened the app yet",
      "addStep": "Add a step",
      "addDoc": "Add a document",
      "custom": "Custom item…",
      "customPlaceholder": "Name for this client",
      "docsTitle": "Client documents — {{done}} of {{total}} ready",
      "remove": "Remove for this client",
      "removeStepConfirm": "Remove step “{{name}}” from the client plan?"
    },
    "concierge": {
      "empty": "No messages yet. Clients write to the bot — conversations show up here.",
      "placeholder": "The reply goes to the client's chat with the bot. ⌘+Enter to send",
      "replyLang": "client language: {{lang}}",
      "send": "Send",
      "you": "You",
      "client": "client",
      "provider": "provider",
      "startHint": "No messages yet — write first, it goes to the chat with the bot.",
      "write": "Message",
      "tab_all": "All",
      "tab_clients": "Clients",
      "tab_providers": "Providers"
    },
    "partners": {
      "name": "Name",
      "category": "Category",
      "offer": "Card offer",
      "address": "Address",
      "summary": "offers: {{offers}} · team: {{members}} · checks: {{visits}}",
      "manage": "Offers and team",
      "offers": "Offers by level",
      "offerTitle": "Offer",
      "minLevel": "Who gets it",
      "allMembers": "All club members",
      "limit": "How often",
      "limitCount": "How many times",
      "limitKind_NONE": "No limit",
      "limitKind_ONCE": "First visit only",
      "limitKind_WEEK": "N times a week",
      "limitKind_MONTH": "N times a month",
      "limit_NONE": "no limit",
      "limit_ONCE": "first visit only",
      "limit_WEEK": "{{count}}× a week",
      "limit_MONTH": "{{count}}× a month",
      "noOffers": "No offers — clients see only the partner description.",
      "team": "Owner and staff",
      "ownerLink": "Owner link",
      "ownerLinkHint": "Send it to the owner or let them scan it: the work bot opens, after Start they become the owner and can invite staff. Single-use.",
      "noTeam": "No one connected yet.",
      "removeConfirm": "Disconnect this person from the partner?"
    },
    "requests": {
      "activate": "Switch on for 30 days",
      "activateConfirm": "Switch on {{plan}} for 30 days?",
      "client": "Client",
      "comment": "Comment",
      "empty": "No requests.",
      "markDone": "Contacted",
      "subscription": "{{plan}} subscription",
      "what": "Request",
      "status_NEW": "New",
      "status_DONE": "Done",
      "status_CANCELLED": "Cancelled"
    },
    "telegram": {
      "title": "Telegram: @{{bot}}",
      "linked": "connected",
      "notLinked": "not connected",
      "what": "The work bot sends you:",
      "e1": "messages from clients and providers — reply right in Telegram with the “Reply” button",
      "e2": "relocation requests — from the site and the app",
      "e3": "app requests — subscriptions and call-backs",
      "e4": "new orders and cleaning requests from the site",
      "how": "Press “Connect” — the work bot opens, press “Start” there. Every operator connects the same way under their own login.",
      "connect": "Connect Telegram",
      "relink": "Connect another Telegram",
      "unlink": "Disconnect",
      "notify": "Send notifications"
    },
    "templates": {
      "STEP": "Moving steps",
      "STEP_hint": "The client plan is built from these: turnkey takes the marked ones, the builder takes those picked in the quiz",
      "DOC": "Documents",
      "DOC_hint": "The checklist every new client gets",
      "sub": "Changes apply to new clients. Edit a specific client’s steps and documents in “Relocation”.",
      "name": "Name",
      "hintField": "Hint",
      "active": "Show to new clients",
      "inTurnkey": "Part of turnkey",
      "turnkey": "turnkey",
      "hidden": "hidden",
      "missing": "missing translation: {{langs}}"
    }
  },
  "landing": {
    "meta": {
      "title": "Barev Club — Yerevan feels like home. From day one",
      "description": "Cleaning, documents, learning and partner discounts for people who moved to Yerevan. All inside Telegram, in 5 languages."
    },
    "nav": {
      "label": "Sections",
      "services": "Services",
      "how": "How it works",
      "plans": "Membership",
      "faq": "FAQ"
    },
    "openTelegram": "Open in Telegram",
    "hero": {
      "tag": "For people who moved to Yerevan",
      "title": "Yerevan feels like home. From day one.",
      "sub": "Home services, documents, learning and partner discounts — one club in Telegram.",
      "cta": "Join for free",
      "services": "See services",
      "cleanTitle": "Apartment cleaning from {{price}}",
      "cleanText": "See the price and pick a time in a minute, no calls.",
      "cleanCta": "Get a cleaning quote"
    },
    "preview": {
      "title": "My orders",
      "inApp": "in the app",
      "cleaning": "Cleaning · deep",
      "cleaningMeta": "Sat 16:00",
      "inWork": "In progress",
      "lesson": "Armenian A1 · lesson 3",
      "lessonMeta": "Today 15:00 · online",
      "today": "Today",
      "cleaningRegular": "Cleaning · regular",
      "cleaningRegularMeta": "Today 12:30"
    },
    "languages": "languages",
    "noInstall": "Nothing to install",
    "noInstallSub": "Everything inside Telegram",
    "dir": {
      "HOME": "Vetted specialists, order status in the app.",
      "HOME_cta": "Book",
      "DOCS": "Notarised translation and support until your document is ready.",
      "DOCS_cta": "Apply",
      "LEARNING": "Online and in person, at a time that suits you.",
      "LEARNING_cta": "Sign up",
      "soonCta": "Get notified at launch"
    },
    "perks": {
      "upTo": "up to −{{pct}}%",
      "cafes": "Cafés",
      "restaurants": "Restaurants",
      "gifts": "Partner gifts",
      "text": "Show your club card in Telegram at the till.",
      "cta": "See partners"
    },
    "how": {
      "titleBold": "How it",
      "titleItalic": "works",
      "step1": "Scan the QR",
      "step1_sub": "From your lease or the website",
      "step2": "Pick a language",
      "step2_sub": "Five languages to choose from",
      "step3": "Book a service",
      "step3_sub": "Time, address, payment",
      "step4": "Track the status",
      "step4_sub": "Chat with your specialist inside"
    },
    "agency": {
      "title": "Rented through a partner real estate agency?",
      "text": "Your code for a month of Barev+ is already in your lease.",
      "gift": "A gift!",
      "giftSub": "1 month of Barev+"
    },
    "plans": {
      "tryPlus": "Try Barev+"
    },
    "faq": {
      "install": {
        "q": "Do I need to install anything?",
        "a": "No. The club works inside Telegram: open the bot and go."
      },
      "languages": {
        "q": "Which languages can I use?",
        "a": "Russian, English, Chinese, Armenian and Spanish."
      },
      "plus": {
        "q": "How is Barev+ different from the free plan?",
        "a": "Discounts of up to {{pct}}% on documents, home services, learning and career coaching."
      },
      "gift": {
        "q": "How do I get the real estate agency gift?",
        "a": "The code is in your lease. Enter it in the bot and get {{days}} days of Barev+."
      }
    },
    "footer": {
      "brand": "Barev Club · Yerevan",
      "partner": "Become a partner",
      "privacy": "Privacy policy",
      "legal": "Sole proprietor Yuri Zabudko · TIN (ՀՎՀՀ) {{tin}}",
      "services": "Services",
      "pricing": "Pricing",
      "terms": "Terms of service",
      "refund": "Refund policy",
      "rules": "Service rules"
    },
    "clean": {
      "meta": {
        "title": "Apartment cleaning in Yerevan — Barev Club",
        "description": "Regular, deep and post-renovation cleaning. See the price right away, pick a time, track your order in Telegram."
      },
      "home": "Home",
      "title": "Apartment cleaning in Yerevan",
      "sub": "See the price and pick a time. We confirm the request in Telegram and send a cleaner.",
      "duration": "About {{hours}} h of work",
      "extrasTitle": "Add to the cleaning",
      "extrasHint": "Anything beyond the standard cleaning.",
      "whenTitle": "When to come",
      "whenHint": "This is your preferred time — we confirm the exact one in Telegram.",
      "noTimes": "No times left for this day — check the next one.",
      "addressTitle": "Address",
      "district": "District",
      "districtPlaceholder": "Choose a district",
      "street": "Street, building, apartment",
      "streetPlaceholder": "For example, Pushkin 10, apt. 5",
      "note": "Note for the cleaner",
      "notePlaceholder": "Intercom code, pets, where the keys are",
      "contactTitle": "Contacts",
      "phone": "Phone",
      "phoneHint": "We only call if we can’t reach you in Telegram.",
      "name": "Your name",
      "consent": "I agree to the processing of my personal data",
      "privacy": "Privacy policy",
      "summaryTitle": "Your cleaning",
      "total": "Total",
      "plusHint": "With Barev+: {{pct}}% off cleaning",
      "submit": "Send request",
      "sending": "Sending…",
      "after": "Telegram opens after you send it: we confirm the time there and show the status.",
      "err": {
        "time": "Pick a time.",
        "district": "Choose a district.",
        "street": "Enter the street and building.",
        "phone": "Enter a phone number with the country code, e.g. +374 91 123456.",
        "consent": "We can’t accept the request without your consent.",
        "network": "Couldn’t send it. Check your connection and try again."
      },
      "doneTitle": "Request No. {{number}} received",
      "doneText": "Telegram is opening — the bot will confirm the request and show its status. If nothing happened, tap the button.",
      "doneCta": "Open Telegram",
      "doneAgain": "Make another request",
      "includedTitle": "What’s included",
      "zone": {
        "kitchen": "Kitchen",
        "bathroom": "Bathroom",
        "rooms": "Rooms"
      },
      "inc": {
        "kitchen": "Clean the sink and faucet\nWipe the stove, countertop and backsplash\nWipe cabinet fronts and appliances outside\nMop the floor and take out the trash",
        "bathroom": "Clean the tub or shower, sink and toilet\nPolish mirrors and faucets\nWipe shelves and doors\nMop the floor",
        "rooms": "Dust accessible surfaces\nVacuum and mop the floor\nMake the bed, tidy things up\nWipe mirrors and switches"
      },
      "general": "Deep cleaning — all of this plus hard-to-reach places: behind furniture, baseboards, doors, radiators and inside cabinets.",
      "renovation": "Post-renovation — also construction dust and traces of paint, glue and cement on every surface.",
      "howTitle": "How it works",
      "how1": "You leave a request here",
      "how1Sub": "The price is shown right away, no calls",
      "how2": "We confirm in Telegram",
      "how2Sub": "The bot shows your order and its status",
      "how3": "A cleaner arrives",
      "how3Sub": "Works by a checklist and sends a photo report",
      "whenHintOptional": "Optional: if you skip it, the bot will ask in Telegram.",
      "addressHintOptional": "Optional: you can send the address to the bot later.",
      "nameTitle": "Your name",
      "consentByClick": "By tapping the button, you agree to the processing of your personal data."
    },
    "v1": {
      "title": "Everything for life in Yerevan — in one chat",
      "sub": "Barev Club is a Telegram bot. Say what you need, see the price right away and pick a time. We handle the rest.",
      "botName": "Barev Club",
      "botStatus": "bot, replies instantly",
      "u1": "Hi! I need a cleaning on Saturday, 2 rooms",
      "b1": "Hi! Regular cleaning, 2 rooms and a bathroom — {{price}}. Does Saturday at 11:00 work?",
      "u2": "Yes, great",
      "b2": "Done. The cleaner arrives at 11:00 — I’ll send the status and a photo report here.",
      "canTitle": "What you can order",
      "canText": "Cleaning is live. The rest launches step by step — the bot will tell you when it opens.",
      "whyTitle": "Why Telegram",
      "why1": "Nothing to install",
      "why1Sub": "The bot and the app open right inside Telegram.",
      "why2": "Five languages",
      "why2Sub": "Russian, English, Chinese, Armenian and Spanish.",
      "why3": "All in one conversation",
      "why3Sub": "Status, chat with your provider and photo report — where you already talk.",
      "ctaTitle": "Start with “Barev”",
      "ctaText": "That’s “hi” in Armenian. Message the bot — it replies in your language.",
      "cta": "Message the bot"
    },
    "v2": {
      "hello": "Привет\nHello\n你好\nԲարև\nHola",
      "title": "Moving to Yerevan, step by step",
      "sub": "From the airport to your own apartment and documents. The club is there at every step, and every question is solved in one chat.",
      "calc": "Get a quote",
      "ctaTitle": "The club is free",
      "ctaText": "Join in Telegram — every step at hand, in your language.",
      "cta": "Join the club",
      "whenArrive": "Arrival",
      "whenWeek": "First week",
      "whenSettled": "After moving in",
      "whenLater": "Next",
      "whenDaily": "Every day",
      "whenAnytime": "Any time",
      "airportTitle": "We meet you at the airport and check you into a hotel",
      "airportText": "A driver with a sign at Zvartnots and a transfer to the hotel — carefree first days.",
      "flatTitle": "We find you an apartment",
      "flatText": "We find a place through partner real estate agencies and clean it before you move in.",
      "docsTitle": "We sort out registration and your social card",
      "docsText": "We prepare the documents, book the appointment and walk you through to the finished card.",
      "permitTitle": "We help with residence permit documents",
      "permitText": "We put the package together, translate and notarize it, and explain deadlines and how to apply.",
      "perksTitle": "Enjoy club discounts and perks",
      "perksText": "Cafés, restaurants and partner gifts with your club card — and with Barev+, discounts on services too.",
      "chatTitle": "Any question — in the chat",
      "chatText": "A broken faucet or an overstayed visit in Armenia — write “help!”, we’ll sort it out and tell you what to do.",
      "chatChip": "in Telegram",
      "chatCta": "Write to the chat"
    },
    "v3": {
      "tag": "For tenants of partner real estate agencies",
      "title": "Welcome home",
      "sub": "The real estate agency you rented through gives you a Barev+ subscription — discounts on cleaning, documents and lessons.",
      "giftTitle": "1 month of Barev+",
      "giftCode": "Code {{code}} applies automatically",
      "giftNoCode": "The code is in your lease",
      "stepsTitle": "How to get it",
      "step1": "Tap “Get the gift”",
      "step1Sub": "The Barev Club bot opens in Telegram.",
      "step2": "Choose a language and confirm consent",
      "step2Sub": "It takes ten seconds.",
      "step3": "The gift turns on by itself",
      "step3Sub": "Discounts apply to your orders right away.",
      "benefitsTitle": "What a month of Barev+ gives you",
      "cleaningDeal": "Cleaning from {{price}} instead of {{full}}",
      "cleaningDealSub": "Regular cleaning, discount already included.",
      "cta": "Get the gift",
      "noCode": "No code? Send it to the bot with /code — or join without one: the club is free."
    },
    "v4": {
      "title": "Landed in Yerevan? We’ll take it from here",
      "sub": "Cleaning, documents and Armenian lessons — order in Telegram in your language, as if you’d lived here for years.",
      "board": "Arrivals",
      "city": "Yerevan",
      "colFlight": "Flight",
      "colService": "Service",
      "colPrice": "Price",
      "colStatus": "Status",
      "live": "Open",
      "soon": "Soon",
      "passTitle": "Boarding pass",
      "passenger": "Passenger",
      "passengerValue": "You",
      "from": "From",
      "fromValue": "Anywhere",
      "to": "To",
      "toValue": "Yerevan, like home",
      "gate": "Gate",
      "gateValue": "Telegram",
      "cta": "Board now",
      "clean": "Order a cleaning right away"
    },
    "v5": {
      "title": "How much you save with Barev+",
      "sub": "An honest calculation: the subscription price is already subtracted from the savings.",
      "perMonth": "Cleanings per month",
      "without": "Without Barev+",
      "with": "With Barev+",
      "withNote": "including the {{price}} subscription",
      "save": "Savings per month",
      "noSave": "For now it’s cheaper without the subscription",
      "breakeven": "Barev+ pays off from {{count}} cleanings of this size per month.",
      "breakevenFirst": "Barev+ pays off from the first cleaning of this size.",
      "perYear": "Per year — {{amount}}",
      "other": "The subscription also covers other categories",
      "cta": "Try Barev+",
      "gift": "Rented through a partner real estate agency? Your subscription is a gift."
    },
    "v6": {
      "tag": "For real estate agencies",
      "title": "An agreement on how your tenants settle into Yerevan",
      "sub": "You give clients a month of Barev+, we help them with everyday life, and you earn a share of their orders.",
      "docDate": "Yerevan",
      "s1": "What the real estate agency gets",
      "s1i1": "{{pct}}% of every client order for {{months}} months after their first visit to the bot.",
      "s1i2": "Your own code and QR — add them to the lease or hand them over with the keys.",
      "s1i3": "A report on clients and orders: how many came, how many ordered and how much you earned.",
      "s2": "What the tenant gets",
      "s2i1": "{{days}} days of Barev+ as a gift — discounts on cleaning, documents and lessons.",
      "s2i2": "A service in five languages inside Telegram — no apps, no calls.",
      "s2i3": "Vetted providers and a status for every order.",
      "s3": "How to join",
      "s3i1": "Message us in the bot — we reply within a day.",
      "s3i2": "Get your agency code and QR.",
      "s3i3": "Add the QR to your lease. We handle the rest.",
      "exampleTitle": "Example",
      "exampleText": "{{clients}} clients × {{orders}} cleanings a month × {{price}}",
      "exampleResult": "{{amount}} to the agency per month",
      "exampleNote": "Based on a regular cleaning of a two-room apartment.",
      "signAgency": "Real estate agency",
      "signUs": "Barev Club",
      "cta": "Become a partner"
    },
    "home": {
      "metaTitle": "Relocation to Armenia: housing, social card, residency — Barev Club",
      "metaDescription": "We meet you at Zvartnots airport, find an apartment in Yerevan, get your social card in 1 day, registration and residence permit paperwork. One Telegram chat, 5 languages.",
      "switchLabel": "Who this page is for",
      "switchMove": "I'm moving",
      "switchLive": "I already live in Armenia",
      "title": "Moving to Armenia, step by step",
      "sub": "We meet you at the airport, find a flat and sort out the paperwork. Every question goes into one chat, in your language.",
      "cta": "Plan my move",
      "ctaChat": "Message us on Telegram",
      "whenArrive": "Arrival",
      "whenFirst": "First days",
      "whenSettled": "Once settled",
      "whenLater": "Later on",
      "whenDaily": "Every day",
      "whenAnytime": "Any time",
      "airportTitle": "Airport pickup and a hotel to start",
      "airportText": "A driver with a sign at Zvartnots, the ride and a hotel room — first days without the hassle.",
      "flatTitle": "We find you a flat",
      "flatText": "Options within 1 day, viewings booked for the next day.",
      "docsTitle": "Registration and social card",
      "docsText": "We prepare the documents and walk you through to the finished card. Social card — the next day.",
      "permitTitle": "Residence permit paperwork",
      "permitText": "Through employment: we put the package together, translate and notarise, and explain the filing timeline.",
      "perksTitle": "Club discounts and perks",
      "perksText": "Discounts on services and partner gifts with Barev+ and Barev Elite.",
      "chatTitle": "Any question — in the chat",
      "chatText": "A leaking tap or an overstayed visa — write “help!”, we'll sort it out and tell you what to do.",
      "chatCta": "Open the chat",
      "finalTitle": "Tell us about your move",
      "finalText": "A few questions and we'll put together a moving plan with a price.",
      "more": "Learn more",
      "perksSoon": "Coming soon"
    },
    "live": {
      "metaTitle": "Discounts on services in Yerevan with a membership — Barev Club",
      "metaDescription": "Club subscription: up to −{{pct}}% on cleaning, repairs, transfers, tours and paperwork, language and career sessions, partner gifts.",
      "title": "Living in Armenia? The club makes it cheaper",
      "sub": "Subscribe and get discounts on the services you need every month.",
      "cta": "Subscribe",
      "ctaPlans": "Compare plans",
      "listTitle": "What the discounts cover",
      "listNote": "The biggest discount comes with Barev Elite. Barev+ gives up to −{{pct}}%.",
      "upTo": "up to −{{pct}}%",
      "discount": "discount",
      "gifts": "gifts",
      "cleaning": "Cleaning",
      "cleaningHint": "regular, deep, after renovation",
      "repair": "Repairs",
      "repairHint": "plumber, electrician, small fixes",
      "transfer": "Transfers",
      "transferHint": "to and from the airport",
      "tours": "Tours",
      "toursHint": "Garni, Geghard, Sevan and more",
      "docs": "Paperwork",
      "docsHint": "social card, residence permit, registration, sole trader and LLC setup",
      "lang": "Languages",
      "langHint": "English and Armenian",
      "career": "Career",
      "careerHint": "CV, LinkedIn profile, interview prep",
      "partners": "Partners",
      "partnersHint": "club cafés, restaurants and shops",
      "finalTitle": "Subscribe in Telegram",
      "finalText": "Open the club bot and pick a plan — discounts show up in service prices.",
      "orderNow": "Book now",
      "docsFrom": "from {{price}} with a subscription"
    },
    "club": {
      "title": "Club subscription",
      "sub": "Ordering services is free. Discounts and a concierge come with a subscription.",
      "free": "free",
      "perMonth": "{{price}}/mo",
      "freeF1": "Order services and track them in the Telegram bot",
      "freeF2": "Payment and a chat for every request",
      "freeF3": "Standard service prices",
      "plusF1": "Up to −{{pct}}% on services",
      "plusF2": "Partner gifts",
      "plusF3": "Concierge in the chat on weekdays, 10:00–18:00",
      "eliteF1": "Up to −{{pct}}% on services",
      "eliteF2": "Partner gifts",
      "eliteF3": "Concierge in the chat 24/7 — any question solved",
      "freeCta": "Open the bot",
      "plusCta": "Get Barev+",
      "eliteCta": "Get Elite"
    },
    "quiz": {
      "dialog": "Plan your move",
      "close": "Close",
      "back": "Back",
      "next": "Next",
      "progress": "Step {{n}} of {{total}}",
      "sending": "Saving…",
      "contactTitle": "What's your name?",
      "name": "Name",
      "contact": "Phone or Telegram",
      "contactHint": "+374 … or @username",
      "consentPre": "By pressing “Next” you agree to the ",
      "consentLink": "privacy policy",
      "errName": "Tell us what to call you.",
      "errContact": "We need a phone number (+374…) or a Telegram username (@username).",
      "movedTitle": "Have you already moved to Armenia?",
      "movedYes": "Yes, I live here",
      "movedNo": "No, I'm planning to",
      "movingToLive": "Opening the page for people who already live in Armenia…",
      "whenTitle": "When are you planning to move?",
      "when_month": "Within a month",
      "when_quarter": "In 1–3 months",
      "when_later": "Later, still looking around",
      "when_date": "I know the date",
      "date": "Arrival date",
      "errWhen": "Pick an option or set a date.",
      "packageTitle": "Which package do you need?",
      "package_CONSULT": "Consultation only",
      "package_CONSULT_text": "We look at your case and draw up a moving plan.",
      "package_TURNKEY": "Turnkey",
      "package_TURNKEY_text": "From the airport pickup to the residence permit or registration. We'll quote the exact price.",
      "package_TURNKEY_price": "on request",
      "package_CUSTOM": "I'll build my own",
      "package_CUSTOM_text": "Pick only the services you need.",
      "customTitle": "Build your package",
      "airport": "Airport pickup",
      "airport_none": "Not needed",
      "airport_standard": "Standard",
      "airport_premium": "Premium",
      "stay": "A place for the first days",
      "stay_none": "Not needed",
      "stay_flat": "Flat",
      "stay_hotel": "Hotel",
      "budget": "Budget per night, ֏",
      "budgetFrom": "from",
      "budgetTo": "to",
      "flat": "Flat search",
      "socialCard": "Social card",
      "bankCard": "Bank card",
      "registration": "Registration",
      "residence": "Residence permit",
      "no": "No",
      "yes": "Yes",
      "yesHint": "We'll get in touch to clarify",
      "errEmpty": "Pick at least one service.",
      "submit": "Send request",
      "doneTitle": "Request #{{number}} received",
      "doneText": "We'll get back to you within a day: {{contact}}.",
      "doneBot": "Open the club in Telegram",
      "doneClose": "Back to the site",
      "errNetwork": "Can't reach the server. Check your connection and try again."
    },
    "seo": {
      "org": "Barev Club is a club service for people moving to Yerevan or already living in Armenia: airport pickup, housing, social card, residence permit, cleaning and partner discounts. All in Telegram, in 5 languages."
    },
    "svc": {
      "common": {
        "home": "Home",
        "updated": "Updated 20 October 2026",
        "factsTitle": "At a glance",
        "pricesTitle": "Prices",
        "faqTitle": "Frequently asked questions",
        "relatedTitle": "More on moving",
        "cta": "Message us on Telegram",
        "ctaMove": "Full relocation package",
        "clean": "Apartment cleaning",
        "breadcrumbs": "Breadcrumbs"
      },
      "socialCard": {
        "meta": {
          "title": "Armenia social card for foreigners: documents, timing, price — Barev Club",
          "description": "How to get a social card (Public Services Number) in Armenia in 2026: documents, where to go and how long it takes. We handle it end to end for {{price}}, usually in 1 day."
        },
        "crumb": "Social card",
        "h1": "Armenia social card: get it in 1 day",
        "lead": "The social card is your Public Services Number (ՀԾՀ), a 10-digit ID. Without it you cannot open a bank account, register as a sole proprietor or apply for residency in Armenia. Foreigners get it at a Migration Service office, usually the same day. Barev Club handles everything for {{price}}: passport translation, appointment and an escort.",
        "priceLabel": "End to end",
        "priceValue": "{{price}}",
        "priceNote": "passport translation, notary, appointment and escort",
        "facts": {
          "f1": {
            "label": "Time",
            "value": "usually 1 day"
          },
          "f2": {
            "label": "Price",
            "value": "{{price}} end to end"
          },
          "f3": {
            "label": "Issued by",
            "value": "Migration Service office (MIA)"
          },
          "f4": {
            "label": "What you need",
            "value": "passport with entry stamp"
          }
        },
        "stepsTitle": "How it works with us",
        "steps": {
          "s1": {
            "when": "Day 1",
            "title": "Message us on Telegram",
            "text": "Send a photo of your passport and your address in Yerevan. A rented flat or hotel address is fine."
          },
          "s2": {
            "when": "Day 1",
            "title": "We get a notarised translation",
            "text": "We translate the main passport page into Armenian and have it notarised."
          },
          "s3": {
            "when": "Day 1",
            "title": "We book the office",
            "text": "We pick an office with a short queue and a time that suits you."
          },
          "s4": {
            "when": "Day 1–2",
            "title": "We go together",
            "text": "Your escort speaks Armenian and fills in the form. You just come with your passport."
          },
          "s5": {
            "when": "Day 1–2",
            "title": "You get your number",
            "text": "The certificate is usually issued on the spot, sometimes the next day."
          }
        },
        "blocks": {
          "b1": {
            "title": "What the social card is",
            "body": "“Social card” is the everyday name for the Public Services Number (ՀԾՀ, PSN). It is a unique 10-digit number the state assigns to Armenian citizens and to foreigners legally present in the country.\nForeigners receive a certificate with the number rather than a plastic card. If you already hold a residence permit, the number may be printed on your residence card."
          },
          "b2": {
            "title": "Why you need it",
            "body": "• open a bank account and card in Armenia;\n• register a sole proprietorship or LLC;\n• pay taxes and receive an official salary;\n• apply for a residence permit;\n• book a doctor at a state clinic;\n• buy a car and get an Armenian driving licence."
          },
          "b3": {
            "title": "Documents you need",
            "body": "• Passport with an Armenian entry stamp.\n• Notarised Armenian translation of the main passport page — we do this for you.\n• An address in Armenia: a rented flat or hotel is fine, no registration needed.\n• If you entered on a Russian internal passport, a notarised translation of it too. This can add a few days.\nSometimes an office asks for a birth certificate or proof of registration. We will tell you in advance if it is needed."
          },
          "b4": {
            "title": "What changes on 1 November 2026",
            "body": "On 1 November 2026 Armenia’s new Law on Foreigners takes effect and the Migration Service booking system changes. We follow the updates and will book you under the current rules."
          }
        },
        "prices": {
          "p1": {
            "name": "Social card, end to end",
            "value": "{{price}}",
            "note": "passport translation, notary, appointment, escort"
          },
          "p2": {
            "name": "With Barev+",
            "value": "−{{docsPct}}%",
            "note": "off all document services"
          }
        },
        "faq": {
          "q1": {
            "q": "Can I get a social card without a residence permit?",
            "a": "Yes. The number is issued to foreigners legally present in Armenia, for example on an entry stamp. You do not need a residence permit."
          },
          "q2": {
            "q": "How long does it take to get a social card?",
            "a": "Most offices issue the certificate the same day, some the next day. We prepare the notarised passport translation in advance, so the whole process usually takes 1–2 days."
          },
          "q3": {
            "q": "Do I need to speak Armenian?",
            "a": "No. An escort who speaks Armenian and English or Russian goes with you and fills in the form for you."
          },
          "q4": {
            "q": "Can I get a social card without going in person?",
            "a": "A representative with a power of attorney can collect the certificate, and with an Armenian electronic signature it can be done online. If you are not in Yerevan, message us and we will find a way."
          },
          "q5": {
            "q": "How is the social card different from a tax ID (ՀՎՀՀ)?",
            "a": "The social card (ՀԾՀ) is a personal number. ՀՎՀՀ is the tax number that sole proprietors and companies receive. You need a social card before you can register as a sole proprietor."
          }
        },
        "finalTitle": "Need a social card?",
        "finalText": "Message us on Telegram — we will book the nearest convenient day and translate your passport."
      },
      "residence": {
        "meta": {
          "title": "Armenia residence permit 2026: new rules from 1 November, grounds, cost — Barev Club",
          "description": "How to get an Armenian residence permit under the new law: employment, sole proprietorship, LLC, family. State fee {{fee}}, online application. Consultation {{consult}}, full support from {{escort}}."
        },
        "crumb": "Residence permit",
        "h1": "Armenia residence permit in 2026: what changed and how to get one",
        "lead": "From 1 November 2026 Armenia’s new Law on Foreigners applies. You apply for a residence permit online, the first permit is issued for 1 year, and the state fee rises to {{fee}}. Grounds include work, a sole proprietorship, an LLC, study or family. Barev Club helps you choose the ground and supports you until you hold your residence card.",
        "priceLabel": "Full support",
        "priceValue": "from {{escort}}",
        "priceNote": "+ state fee {{fee}}. Consultation {{consult}} is credited",
        "facts": {
          "f1": {
            "label": "New rules",
            "value": "from 1 November 2026"
          },
          "f2": {
            "label": "State fee",
            "value": "{{fee}} for 1 year"
          },
          "f3": {
            "label": "Application",
            "value": "online + one visit for fingerprints"
          },
          "f4": {
            "label": "Full support",
            "value": "from {{escort}}"
          }
        },
        "stepsTitle": "How we handle your residence permit",
        "steps": {
          "s1": {
            "when": "Week 1",
            "title": "Consultation",
            "text": "We review your situation and choose the ground: work, sole proprietorship, LLC or family. The {{consult}} consultation is credited towards full support."
          },
          "s2": {
            "when": "Week 1–2",
            "title": "We set up the ground",
            "text": "We help you open a sole proprietorship or LLC, deposit the required amount or sign an employment contract."
          },
          "s3": {
            "when": "Week 2–3",
            "title": "We prepare documents",
            "text": "We translate and notarise documents and get your social card if you do not have one yet."
          },
          "s4": {
            "when": "Filing",
            "title": "We apply online",
            "text": "We complete the application on the government portal and answer any Migration Service requests."
          },
          "s5": {
            "when": "Visit",
            "title": "You give fingerprints",
            "text": "You visit the Migration Service once in person to give fingerprints and sign. We go with you."
          },
          "s6": {
            "when": "Done",
            "title": "You get your residence card",
            "text": "We tell you the decision and help you collect the card."
          }
        },
        "blocks": {
          "b1": {
            "title": "What changed on 1 November 2026",
            "body": "• The amended Law on Foreigners was adopted on 20 January 2026 and applies from 1 November 2026.\n• Applications are filed online through a single portal. You come in person once to give fingerprints and sign; a power of attorney cannot replace this.\n• The first permit is issued for 1 year. Permanent 5-year residence requires 3 years of temporary residence within the last 5.\n• The fee for a 1-year permit is 150,000 ֏ plus 5,950 ֏ for the card; permanent residence costs 255,950 ֏.\n• The government introduces annual quotas. Once a quota is used up, new applications are refused.\n• The special 10-year status for ethnic Armenians is no longer issued; existing documents stay valid until expiry.\n• Applications filed before 1 November are decided under the old rules. Existing permits are valid until the date on the card; the new rules apply at renewal."
          },
          "b2": {
            "title": "Grounds for a residence permit",
            "body": "• Work: an employment contract with an Armenian company. The labour market test is abolished and replaced by a quota.\n• Sole proprietorship: 1,000,000 ֏ in an Armenian bank account when you apply, or the same turnover in the 60 days before applying.\n• LLC: a capital contribution or share purchase of at least 2,000,000 ֏. If no tax is assessed within 180 days of approval, the permit can be cancelled.\n• Study: not only universities but also courses, vocational training and exchange programmes.\n• Family: spouse, parent or child of an Armenian citizen or of a foreigner with residence status.\nBuying an apartment does not by itself give you the right to a residence permit."
          },
          "b3": {
            "title": "Documents you will need",
            "body": "• your passport and its notarised Armenian translation;\n• proof of the ground: employment contract, sole proprietorship or LLC registration, bank statement, marriage or birth certificate;\n• your social card (Public Services Number);\n• receipt for the state fee.\nThe exact list is set by government regulations. We check it against the current version at the consultation."
          },
          "b4": {
            "title": "Can you live in Armenia without a residence permit?",
            "body": "Russian citizens enter without a visa and can stay up to 180 days per entry. Other nationalities follow their own rules. If your time is running out and you have no permit yet, overstaying can lead to a fine. Message us early and we will tell you what can still be done."
          },
          "b5": {
            "title": "Please note",
            "body": "This information is current as of 20 October 2026. Some rules are being detailed in regulations, so we check requirements with the Migration Service before every application. This page is not legal advice."
          }
        },
        "prices": {
          "p1": {
            "name": "Consultation",
            "value": "{{consult}}",
            "note": "credited towards full support"
          },
          "p2": {
            "name": "Full support until you get the card",
            "value": "from {{escort}}",
            "note": "ground, documents, filing, visit"
          },
          "p3": {
            "name": "State fee, 1-year permit",
            "value": "{{fee}}",
            "note": "paid to the state, from 1 November 2026"
          },
          "p4": {
            "name": "State fee, 5-year permit",
            "value": "255,950 ֏",
            "note": "after 3 years of temporary residence"
          }
        },
        "faq": {
          "q1": {
            "q": "How much does an Armenian residence permit cost in 2026?",
            "a": "From 1 November 2026 the state fee for a 1-year permit is {{fee}}: 150,000 ֏ duty plus 5,950 ֏ for the card. With a sole proprietorship you also need 1,000,000 ֏ in the account or the same turnover over 60 days. Barev Club full support starts from {{escort}}."
          },
          "q2": {
            "q": "How long does a residence permit decision take?",
            "a": "The Migration Service has not yet published processing times for the new system. We will give you a realistic estimate at the consultation once the first decisions under the new rules come through."
          },
          "q3": {
            "q": "Can I get an Armenian residence permit by buying property?",
            "a": "No. Under the new law, owning property does not by itself give you the right to a residence permit. You need work, a business, study or family ties."
          },
          "q4": {
            "q": "Do I need to come in person?",
            "a": "Yes, once: to give fingerprints and sign the application in Armenia. A power of attorney cannot replace this; everything else is online."
          },
          "q5": {
            "q": "What happens to the residence permit I already have?",
            "a": "It stays valid until the expiry date on the card. The new rules, fee and online application apply when you renew."
          },
          "q6": {
            "q": "Can I get a 5-year residence permit straight away?",
            "a": "Usually not: you first get a 1-year permit, and permanent residence after 3 years of temporary residence within the last 5. Exceptions are ethnic Armenians, investors and people with exceptional services to Armenia."
          }
        },
        "finalTitle": "Let’s look at your case",
        "finalText": "Tell us about yourself on Telegram — we will choose the right ground and calculate the full cost."
      },
      "airport": {
        "meta": {
          "title": "Zvartnots airport transfer to Yerevan with meet and greet — Barev Club",
          "description": "We meet you at Zvartnots with a name sign, help with luggage and drive you to your home or hotel in Yerevan. Standard {{standard}}, Premium {{premium}}. Flight tracking, 60 minutes free waiting."
        },
        "crumb": "Airport transfer",
        "h1": "Zvartnots airport transfer with meet and greet",
        "lead": "Your driver meets you in the Zvartnots arrivals hall with a name sign, helps with your luggage and takes you to any address in Yerevan. The ride to the centre takes 20–30 minutes. Standard costs {{standard}} per car for up to 3 passengers, Premium {{premium}}. We track your flight, and the first 60 minutes of waiting are free.",
        "priceLabel": "Standard pickup",
        "priceValue": "{{standard}}",
        "priceNote": "up to 3 passengers, name sign, 60 minutes waiting",
        "facts": {
          "f1": {
            "label": "Meeting point",
            "value": "arrivals hall, with a name sign"
          },
          "f2": {
            "label": "To the centre",
            "value": "20–30 minutes"
          },
          "f3": {
            "label": "Standard",
            "value": "{{standard}}"
          },
          "f4": {
            "label": "Premium",
            "value": "{{premium}}"
          }
        },
        "stepsTitle": "How the pickup works",
        "steps": {
          "s1": {
            "when": "Before you fly",
            "title": "Send your flight number",
            "text": "Message us on Telegram with your flight number, passengers, suitcases and address in Yerevan."
          },
          "s2": {
            "when": "Before you fly",
            "title": "Get your driver’s details",
            "text": "We send the driver’s name, car number and a chat with the driver in the bot."
          },
          "s3": {
            "when": "Arrival",
            "title": "We track your flight",
            "text": "If your flight is delayed, the driver arrives for the new time at no extra cost."
          },
          "s4": {
            "when": "Arrival",
            "title": "Meet and greet",
            "text": "The driver waits in arrivals with a sign bearing your name and helps with luggage."
          },
          "s5": {
            "when": "30 minutes later",
            "title": "You’ve arrived",
            "text": "We drop you at your flat or hotel in Yerevan."
          }
        },
        "blocks": {
          "b1": {
            "title": "What’s included",
            "body": "• meeting in the arrivals hall with a name sign;\n• help with luggage;\n• up to 3 passengers on Standard;\n• flight tracking;\n• 60 minutes of free waiting after landing;\n• chat with the driver via the bot.\nPremium adds a business-class car, water in the car and an Armenian SIM card so you are connected as soon as you land."
          },
          "b2": {
            "title": "A hotel for your first days",
            "body": "If you do not have a flat yet, we book a hotel and drive you straight there. With Barev+ from {{hotelPlus}} per night, without a subscription from {{hotelBase}}."
          },
          "b3": {
            "title": "Other ways to get from Zvartnots",
            "body": "• Taxi from the airport desk: according to travel guides, usually 3,000–7,000 ֏ to the centre, but nobody meets you in arrivals.\n• Taxi apps such as Yandex Go: cheap, but you have to find the car in the car park yourself.\n• A transfer with meet and greet costs more, but the driver waits in arrivals, tracks your flight and helps with luggage. It is handy if you travel with family, arrive late or come to Armenia for the first time."
          }
        },
        "prices": {
          "p1": {
            "name": "Standard",
            "value": "{{standard}}",
            "note": "up to 3 passengers, name sign, 60 minutes waiting"
          },
          "p2": {
            "name": "Premium",
            "value": "{{premium}}",
            "note": "business class, water, SIM card"
          },
          "p3": {
            "name": "Hotel with Barev+",
            "value": "from {{hotelPlus}}",
            "note": "per night; without a subscription from {{hotelBase}}"
          },
          "p4": {
            "name": "With Barev+",
            "value": "−{{homePct}}%",
            "note": "off transfers and home services"
          }
        },
        "faq": {
          "q1": {
            "q": "How much is a transfer from Zvartnots airport to central Yerevan?",
            "a": "With Barev Club it is {{standard}} per car for up to 3 passengers with meet and greet, Premium {{premium}}. A taxi from the airport desk usually costs 3,000–7,000 ֏, but without anyone meeting you in arrivals."
          },
          "q2": {
            "q": "What if my flight is delayed?",
            "a": "We track your flight and the driver arrives for the actual landing time. The first 60 minutes after landing are free."
          },
          "q3": {
            "q": "How long is the drive from the airport to central Yerevan?",
            "a": "About 20–30 minutes without traffic: Zvartnots airport is roughly 12 km west of the city centre."
          },
          "q4": {
            "q": "Can I book a transfer to the airport?",
            "a": "Yes. We drive you to Zvartnots from any address in Yerevan for the same price."
          },
          "q5": {
            "q": "How do I book a pickup?",
            "a": "Message us on Telegram with your flight number, passengers and address, ideally at least a day before you land."
          }
        },
        "finalTitle": "Flying to Yerevan?",
        "finalText": "Send your flight number on Telegram — we will meet you and drive you to your door."
      }
    },
    "pay": {
      "cardCta": "Pay by card",
      "redirecting": "Opening payment…",
      "orTelegram": "or sign up in Telegram",
      "approx": "≈ {{amd}} · ≈ {{rub}}, charged in euros, renews monthly",
      "error": "Couldn’t open the payment page. Try again or sign up in Telegram.",
      "metaTitle": "Membership payment — Barev Club",
      "checking": "Checking your payment…",
      "pendingTitle": "Waiting for payment confirmation",
      "pendingText": "It usually takes a few seconds — this page updates by itself.",
      "backToPayment": "Back to payment",
      "paidTitle": "Payment received! {{plan}} is ready to activate",
      "paidText": "The club lives in Telegram. Tap the button — the bot will link the membership to your account and discounts start working right away.",
      "activate": "Activate in Telegram",
      "renewNote": "The membership renews every month for {{price}}. You can turn off renewal in the app under “Membership”.",
      "claimedTitle": "{{plan}} is active",
      "claimedText": "The membership is linked to your Telegram. Open the bot — discounts already apply.",
      "openBot": "Open the bot",
      "failedTitle": "Payment failed",
      "failedText": "You were not charged. Try again or use another card.",
      "retry": "Try again",
      "refundedTitle": "Payment refunded",
      "notFoundTitle": "Payment not found",
      "notFoundText": "Check the link or message us — we’ll help."
    }
  },
  "privacy": {
    "title": "Privacy policy",
    "updated": "Version of 22 October 2026",
    "intro": "This policy explains what personal data Barev Club collects, why, who we share it with and how you can control it. It applies to barevclub.com, the Barev Club Telegram bots and mini apps.",
    "operator": {
      "title": "Who processes your data",
      "body": "The personal data controller is sole proprietor Yuri Konstantinovich Zabudko (Ա/Ձ Զաբուդկո Յուրի Կոնստանտինի), Republic of Armenia, tax ID (ՀՎՀՀ) {{tin}}. Barev Club is the name of the service.\nFor data questions, email {{email}}, call {{phone}} or write in the bot chat."
    },
    "data": {
      "title": "What data we receive",
      "body": "• From Telegram: your ID, username, first and last name from your profile, language. Your phone number only if you choose to share it.\n• Website requests: name, phone or Telegram username, your answers in the relocation planner (dates, services needed, budget). For cleaning: address, district, preferred time and comment.\n• Orders: address and district, map location (if you set one), service options, date and time, price, discount, payment status, comments.\n• Documents: scans of your passport and other documents you upload for Documents services.\n• Messages with the specialist via the bot, photo reports, ratings and reviews.\n• Membership: tier (Barev, Barev+, Elite), subscription dates, club card code and records of its use at partners.\n• Source: the agency or promo code you came with and campaign tags (UTM).\n• Technical data: a cookie with the site language, the agency code in browser storage and server logs (IP address, time and requested address) to protect against failures and attacks.\nWe do not receive bank card details: for online payments they are entered on the page of the Tribute payment service (tribute.tg)."
    },
    "purposes": {
      "title": "Why we use it",
      "body": "• To take and fulfil your order: pick a specialist, calculate the price, send status updates.\n• To contact you about your request and prepare a relocation plan.\n• To run your membership, club card and discounts.\n• To calculate the reward for the agency that referred you and payouts to specialists.\n• To keep accounting and tax records.\n• To improve the service based on ratings and reviews.\n• To send club news and offers, unless you have opted out."
    },
    "basis": {
      "title": "Legal basis",
      "body": "We process data based on the consent you give in the bot or in a website form, to fulfil your order, and to comply with the laws of the Republic of Armenia, including the Law on Protection of Personal Data.\nYou can withdraw consent at any time. This does not affect processing carried out before withdrawal."
    },
    "recipients": {
      "title": "Who we share data with",
      "body": "We do not sell personal data and share only what a specific task needs:\n• The specialist doing your order and, if a partner company does it, the company’s dispatcher: name, language, address and order details. Your phone number is not shown to the specialist; you talk via the bot.\n• The real estate agency that referred you: your name, whether you use the club and the amounts of paid orders, to calculate the agency’s reward.\n• A club partner when you show your club card: your name and membership tier.\n• Telegram, which runs the bots and mini apps and processes data under its own policy.\n• Hostinger International, whose servers store the database and files.\n• The Tribute payment service (tribute.tg), which processes online payments: email (if you provided it), amount, payment purpose and an internal customer number. Tribute processes card details on its side under its own privacy policy.\n• Government bodies, when you order a documents service and we file on your behalf, or when the law requires it."
    },
    "location": {
      "title": "Where data is stored",
      "body": "The database and files are stored on a server in Germany (Frankfurt am Main, provider Hostinger). Germany is in the European Union, where the General Data Protection Regulation (GDPR) applies.\nBy giving consent you agree to your data being transferred outside Armenia. Telegram may process data in other countries."
    },
    "retention": {
      "title": "How long we keep data",
      "body": "• Profile: while you use the service or until you ask us to delete it.\n• Orders and payments: 5 years after the order is completed, as accounting and tax rules require.\n• Messages with the specialist and photo reports: 1 year after the order is completed.\n• Website requests that did not lead to an order: 12 months.\n• Document scans: 90 days after the order is completed, then deleted automatically.\nWhen the period ends, data is deleted or anonymised."
    },
    "security": {
      "title": "How we protect data",
      "body": "• The website and apps work only over HTTPS.\n• Document scans are kept in encrypted storage. Only the operator and the assigned specialist can open them, via temporary links, and every view is logged.\n• The admin panel is protected by a password and two-factor authentication, and admin actions are logged.\n• We back up the database every day."
    },
    "rights": {
      "title": "Your rights",
      "body": "You can:\n• find out what data we hold about you and get a copy;\n• correct inaccurate data;\n• delete your data and profile, except data we must keep by law;\n• withdraw consent to processing;\n• opt out of news and offers;\n• complain to the Personal Data Protection Agency of the Ministry of Justice of the Republic of Armenia.\nEmail {{email}} or write in the bot chat. We will reply within the time set by the laws of the Republic of Armenia. Without consent to processing we cannot accept new orders."
    },
    "marketing": {
      "title": "News and offers",
      "body": "From time to time we send club news, promotions and partner offers in the bot. You can opt out at any time: write “unsubscribe” in the bot chat or email {{email}}.\nMessages about orders, your subscription and booking reminders are sent regardless."
    },
    "cookies": {
      "title": "Cookies",
      "body": "The website sets one cookie, barev_lang, with your chosen language so it opens in that language next time. If you came via an agency link, its code is saved in browser storage so your discount is not lost. The website uses no advertising or analytics cookies."
    },
    "age": {
      "title": "Age",
      "body": "The service is for adults. If you are under 18, please do not give us your data. Children’s data, for example for family documents, is provided by a parent or legal guardian, who is responsible for it."
    },
    "changes": {
      "title": "Changes to this policy",
      "body": "We may update this policy. The current version is always on this page, with its date at the top. We will tell you about significant changes in the bot.\nThe Russian text is the main version; translations are provided for convenience."
    }
  },
  "pricing": {
    "title": "Pricing",
    "updated": "Effective from 22 October 2026",
    "intro": "What the Barev Club membership and club services cost. You can order services without a membership — it only adds discounts and a concierge. All prices are in Armenian dram (֏).",
    "from": "from {{price}}",
    "perDay": "{{price}} per night",
    "plansTitle": "Club membership",
    "plansNote": "The membership is billed monthly and renews until you cancel it. You can cancel at any time — it stays active until the end of the paid month.",
    "planNote": {
      "free": "Sign up in the Telegram bot. No payment, no time limit.",
      "plus": "Subscribe in the bot. If you came through a partner real estate agency, the subscription is a gift (usually {{days}} days or more — each agency sets its own terms).",
      "elite": "Arranged through a club operator in the bot chat."
    },
    "servicesTitle": "Services",
    "servicesNote": "These are base prices. Before you confirm an order, the bot shows its exact price, including your options and membership discount. Once confirmed, the price does not change.",
    "rows": {
      "cleaning": {
        "name": "Apartment cleaning",
        "note": "Depends on the type of cleaning and the number of rooms"
      },
      "transferStandard": {
        "name": "Zvartnots airport transfer, Standard",
        "note": "Up to 3 passengers, name sign, 60 minutes of waiting"
      },
      "transferPremium": {
        "name": "Zvartnots airport transfer, Premium",
        "note": "Business class, water, SIM card"
      },
      "hotel": {
        "name": "Hotel for the first days",
        "note": "Price with Barev+; without a membership — from {{base}} per night"
      },
      "socialCard": {
        "name": "Social card, end to end",
        "note": "Passport translation, notary, appointment, escort"
      },
      "consultation": {
        "name": "Residence permit consultation",
        "note": "Credited towards the support fee"
      },
      "residence": {
        "name": "Residence permit support",
        "note": "Grounds, documents, application, visit. The state fee of {{fee}} for a 1-year permit is paid to the state separately"
      }
    },
    "payTitle": "Payment and cancellation",
    "payBody": "Barev+ and Elite memberships are paid by card in euros on the website or in the app and renew automatically every month — you can turn off renewal at any time. Payments are processed by Tribute; membership payments are refundable on request within 14 days. Service orders can be paid online in the app (in euros at the current rate) or in cash or by transfer. You can cancel or reschedule an order for free up to 24 hours before the service starts. See the terms of service and the refund policy for details."
  },
  "terms": {
    "title": "Terms of service",
    "updated": "Version of 22 October 2026",
    "intro": "These are the terms on which Barev Club provides services through barevclub.com, its Telegram bots and mini apps. By placing an order or subscribing, you accept these terms.",
    "about": {
      "title": "Who we are and what we do",
      "body": "Barev Club is a service for people moving to Armenia or already living here: household services (cleaning, airport transfer, a hotel for the first days), help with documents (social card, residence permit), learning, and discounts from club partners.\nServices are provided by sole proprietor Yuri Konstantinovich Zabudko (Ա/Ձ Զաբուդկո Յուրի Կոնստանտինի), Republic of Armenia, TIN (ՀՎՀՀ) {{tin}}. Contacts: {{email}}, {{phone}}.\nOrders are carried out by vetted providers — our staff or partner companies. Barev Club is responsible to you for the result."
    },
    "acceptance": {
      "title": "Accepting the terms",
      "body": "These terms apply from the moment you place an order, subscribe or send a request on the website or in the bot. You must be 18 or older to use the service.\nIf you do not agree with the terms, please do not place an order."
    },
    "orders": {
      "title": "How orders work",
      "body": "• You choose a service in the bot or send a request on the website and specify the details: address, date, time and so on.\n• Before you confirm, the bot shows the total price, discount and cancellation terms.\n• An order is accepted once you have confirmed it and we have assigned a provider. You get a notification about this and every later status.\n• You talk to the provider through the chat in the bot.\nIf we cannot fulfil the order at the chosen time, we will offer another time or cancel the order with no charge."
    },
    "prices": {
      "title": "Prices",
      "body": "Prices are listed in Armenian dram on the Pricing page and in the bot. We may change prices, but the price of an order you have already confirmed does not change.\nState fees and duties, such as the residence permit fee, are not included in the service price unless stated explicitly. We tell you the amount in advance."
    },
    "payment": {
      "title": "Payment",
      "body": "Barev+ and Barev Elite memberships can be paid online by card on the website or in the app. The membership renews automatically every month from the same card; you can turn off renewal at any time in the app (“Membership”) or by messaging us — the paid month stays active. Service orders can be paid online in the app — the amount is converted from drams to euros at the rate shown before payment. Online payments are processed by the Tribute payment service (tribute.tg); card details are entered on its page, and we do not receive or store them.\nServices (cleaning, transfers, documents and others) are not sold online: they are paid in cash or by transfer to the provider, or by bank transfer to Barev Club — you choose the method in the order.\nWe issue a payment receipt on request."
    },
    "cancel": {
      "title": "Cancellation and rescheduling",
      "body": "You can cancel or reschedule an order for free up to 24 hours before the service starts — in the bot or in the chat with an operator.\nFor later cancellations, part of the price is withheld. The amount is shown on the service card before you confirm the order; by default it is 30%.\nIf we cancel the order or the provider does not show up, you get a full refund. See the refund policy for details."
    },
    "subscription": {
      "title": "Barev+ and Barev Elite membership",
      "body": "• The membership gives discounts on club services, gifts from partners and a concierge in chat. Tiers and prices are on the Pricing page.\n• The membership is billed monthly and renews automatically until you cancel it. We remind you 3 days before renewal.\n• The discount applies to orders placed while the membership is active.\n• The free period with a partner agency code is given once per client.\n• You can cancel at any time in the bot or in the chat with an operator. The membership stays active until the end of the paid period."
    },
    "perks": {
      "title": "Partner discounts and gifts",
      "body": "Discounts and gifts with the club card are provided by club partners — cafés, restaurants and other businesses. The terms of each offer are shown in the partner catalogue.\nThe partner is responsible for its own goods and services. Partner offers may change or end."
    },
    "docs": {
      "title": "Document services",
      "body": "We help you gather documents, translate them, book appointments and accompany you to state offices. The decision to issue a document or residence permit is made by the state authority, and we cannot guarantee it.\nYou are responsible for the documents and information you give us being genuine and accurate. If a refusal is caused by our mistake, we will fix it at our own cost."
    },
    "client": {
      "title": "Your obligations",
      "body": "• Provide correct details: address, contacts, order options.\n• Give access to the apartment at the agreed time and safe conditions for the provider's work.\n• Treat providers and operators with respect.\n• Do not use the service for unlawful purposes.\nIf the provider cannot start work because of you (for example, nobody is at the address), this counts as a late cancellation."
    },
    "quality": {
      "title": "Quality and complaints",
      "body": "If you are not happy with the result, write in the order chat within 24 hours of completion and attach photos if you can. We will fix the issues for free or refund part or all of the price.\nIf a provider damages your property, tell us within 24 hours — we will look into it and compensate confirmed damage."
    },
    "liability": {
      "title": "Liability",
      "body": "Our liability for an order is limited to its price, except for confirmed damage to property and cases where the law does not allow such a limit.\nWe are not liable for delays and cancellations caused by circumstances beyond our control: decisions of state authorities, flight delays, natural disasters, Telegram outages."
    },
    "content": {
      "title": "Website content",
      "body": "The texts, design, logo and the Barev Club name belong to the owner of the service. Do not copy them without permission."
    },
    "changes": {
      "title": "Changes to the terms",
      "body": "We may update these terms. The current version is always on this page, with its date at the top. Orders already confirmed are carried out on the previous terms. We will notify you in the bot in advance about significant changes to the membership."
    },
    "law": {
      "title": "Governing law and disputes",
      "body": "These terms are governed by the laws of the Republic of Armenia. We first try to settle disputes by negotiation — write to {{email}} and we will reply within 3 business days. If we cannot agree, the dispute is heard by a court of the Republic of Armenia.\nThese terms do not limit your statutory consumer rights.\nThe original text is in Russian; translations are provided for convenience."
    }
  },
  "refund": {
    "title": "Refund policy",
    "updated": "Version of 22 October 2026",
    "intro": "When and how much Barev Club refunds for services and membership, and how to request a refund.",
    "cancelClient": {
      "title": "If you cancel",
      "body": "• 24 hours or more before the service starts — cancelling and rescheduling are free, and you get a full refund.\n• Less than 24 hours before — part of the price is withheld and the rest is refunded. The amount is shown on the service card before you confirm the order; by default it is 30%.\n• Once the service has started, the part already done is not refunded."
    },
    "cancelUs": {
      "title": "If we cancel",
      "body": "If we cancel the order, cannot find a provider, or the provider does not show up, you choose: reschedule to a convenient time or get a full refund."
    },
    "quality": {
      "title": "If you are not happy with the result",
      "body": "Write in the order chat within 24 hours of completion and attach photos if you can. We will fix the issues for free, and if that is not possible, refund part or all of the price depending on what went wrong."
    },
    "subscription": {
      "title": "Barev+ and Barev Elite membership",
      "body": "• Any membership payment is refunded in full if you ask within 14 days of the charge.\n• You can cancel at any time — the next payment will not be charged, and the membership stays active until the end of the paid month.\n• The free period costs nothing, so there is nothing to refund."
    },
    "nonRefundable": {
      "title": "What is not refundable",
      "body": "• State fees and duties we have already paid on your behalf.\n• Costs we have already paid to third parties for your order: for example, a notarised translation or a hotel booking under the hotel's rules.\n• Goods and services of club partners — the partner's own rules apply."
    },
    "howTo": {
      "title": "How to request a refund",
      "body": "Write in the bot chat or to {{email}} with your order or membership number and the reason. We will reply within 3 business days.\nIf you paid online, the money is returned to the same card through the Tribute payment service — usually within a few business days after we confirm."
    },
    "timing": {
      "title": "Timing and method",
      "body": "Refunds are made by the same method you used to pay, within 10 business days after the refund is approved. A card refund may take a few more days depending on your bank. If you paid in cash, we refund by transfer or in cash, whichever you prefer.\nRefund questions: {{email}}, {{phone}}."
    }
  }
}
